import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle,useMemo ,useCallback} from 'react';
import AssetService from "../../services/AssetService";
import FleetService from "../../services/FleetService";
import FacilityService from "../../services/FacilityService";
import { If } from "../../utils/Controls";
//import ExcelImportModal from './ExcelImportModal';
import { AntdPaging, AntdSelect, AntdDatepicker } from "../../utils/Antd";
import util from "../../utils/util";
import plus from './icons/plus.svg'
import search from './icons/magnifying-glass-solid.svg'
import pen from './icons/pen-to-square-solid.svg'
import share from './icons/share-solid.svg'
import moment from "moment"; 
import SmartPhotoCapture from './SmartPhotoCapture';
import SmartDuplicateDetector from './SmartDuplicateDetector';
import VoiceRemarks from './VoiceRemarks';
import IntelligentExcelImport from './IntelligentExcelImport';
import MobileSmartCapture from './MobileSmartCapture';
import VehicleDocumentsUpload from './VehicleDocumentsUpload';
import VehicleDocInline from './VehicleDocInline';
import FleetExport from '../fleet/FleetExport';
import { 
    BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
    AreaChart, Area,  // Add these
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer 
} from 'recharts';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import {Table, Space, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined,
    CheckCircleOutlined, 
    ExclamationCircleOutlined, 
    CloseCircleOutlined, 
    InfoCircleOutlined, FileExcelOutlined,
DownloadOutlined, BarChartOutlined,FilterOutlined} from '@ant-design/icons';
import PhotoCapture from './PhotoCapture';
import PhotoViewer from './PhotoViewer';
import {
    Input,
    Button,
    message,
    DatePicker  ,
    Modal,
    Divider,
    Tabs,
    Card,         
    Row,         
    Col,        
    Statistic,    
    Progress, 
    Tag,
    Spin,
    Select,
    Alert,
    Select as AntSelect
} from 'antd';

// ─── Status History Timeline Component ──────────────────────────────────────
function StatusHistoryButton({ assetId, regNo }) {
    const [open, setOpen]       = React.useState(false);
    const [history, setHistory] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const load = async () => {
        if (history.length) { setOpen(true); return; }
        setLoading(true);
        try {
            const res = await FleetService.getStatusHistory(assetId);
            if (Number(res?.data?.code) === 200) {
                setHistory(res.data.result || []);
            }
        } catch (e) { console.error(e); }
        finally { setLoading(false); setOpen(true); }
    };

    const statusColor = (s) => {
        if (!s) return '#d9d9d9';
        const sl = (s || '').toLowerCase();
        if (/board|dispos|ground/i.test(sl)) return '#f5222d';
        if (/repair|await/i.test(sl))        return '#faad14';
        if (/good|function|fair/i.test(sl))  return '#52c41a';
        return '#1890ff';
    };

    return (
        <>
            <div
                onClick={e => { e.stopPropagation(); load(); }}
                style={{ cursor:'pointer', fontSize:10, color:'#1677ff', marginTop:4,
                    display:'inline-flex', alignItems:'center', gap:3 }}>
                {loading ? '⏳' : '📋'} Status History
            </div>
            <Modal open={open} onCancel={() => setOpen(false)} width={480}
                footer={<Button onClick={() => setOpen(false)}>Close</Button>}
                title={`Status History — ${regNo}`} destroyOnClose>
                {history.length === 0 ? (
                    <div style={{ textAlign:'center', color:'#aaa', padding:30 }}>
                        No status change history recorded yet.
                    </div>
                ) : (
                    <div style={{ position:'relative', paddingLeft:20 }}>
                        {/* Vertical line */}
                        <div style={{ position:'absolute', left:7, top:8, bottom:8,
                            width:2, background:'#e8e8e8', borderRadius:2 }} />
                        {history.map((h, i) => (
                            <div key={i} style={{ display:'flex', gap:12, marginBottom:16, position:'relative' }}>
                                {/* Dot */}
                                <div style={{
                                    width:14, height:14, borderRadius:'50%', flexShrink:0,
                                    background: statusColor(h.new_status),
                                    border:'2px solid #fff', boxShadow:'0 0 0 1px #e8e8e8',
                                    marginTop:2, zIndex:1,
                                }} />
                                <div style={{ flex:1 }}>
                                    <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                                        {h.old_status && (
                                            <>
                                                <span style={{ fontSize:11, color:'#aaa',
                                                    textDecoration:'line-through' }}>{h.old_status}</span>
                                                <span style={{ fontSize:10, color:'#ccc' }}>→</span>
                                            </>
                                        )}
                                        <span style={{ fontSize:12, fontWeight:600,
                                            color: statusColor(h.new_status) }}>
                                            {h.new_status}
                                        </span>
                                    </div>
                                    <div style={{ fontSize:11, color:'#888', marginTop:2 }}>
                                        {h.timestamp
                                            ? new Date(h.timestamp).toLocaleDateString('en-GB',
                                                { day:'2-digit', month:'short', year:'numeric',
                                                  hour:'2-digit', minute:'2-digit' })
                                            : '—'}
                                        {h.changed_by && ` · ${h.changed_by}`}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Modal>
        </>
    );
}

export default function Assets() {
    const [clients, setClients] = useState([]);
    const [items, setItems] = useState([]);
    const [stationPoints, setStationPoints] = useState([]);
    const [functionalStatus, setFunctionalStatus] = useState([]);
    
    const onTabChange = (key) => {
        setTab(key);
    }

useEffect(() => {
    // Load items from all categories for baseline management
    const loadAllItems = async () => {
        try {
            const categories = ['2', '3', '8', '9']; // All your asset categories
            let allItems = [];
            
            for (const categoryId of categories) {
                try {
                    const res = await AssetService.allItems({ 
                        status: 1, 
                        asset_cat_id: categoryId 
                    });
                    
                    if (res.data?.result?.data?.length > 0) {
                        const categoryItems = res.data.result.data.map((v) => {
                            if (v.asset_cat_id === '8') {
                                v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
                            } else {
                                v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
                            }
                            return v;
                        });
                        allItems = [...allItems, ...categoryItems];
                    }
                } catch (error) {
                    console.error(`Error loading category ${categoryId}:`, error);
                }
            }
            
            setItems(allItems);
            console.log('Loaded all items:', allItems.length, 'items');
            
        } catch (error) {
            console.error('Error loading items:', error);
        }
    };
    
    loadAllItems();
    
    // Your other API calls
    FacilityService.all({ status: 1, include_me: 'Y' }).then(res => {
        let allClients = res.data.result.data.map(v => { 
            return { id: v.id, name: v.business_name, is_national: v.is_national, is_me: v.is_me , site_type: v.site_type || v.level || 'Unknown' } 
        });
        setClients(allClients);
    });

    FacilityService.allStationPoints({ status: 1 }).then(res => {
        setStationPoints([...res.data.result.data]);
    });
    
    AssetService.allFunctionalStatus().then(res => {
        setFunctionalStatus([...res.data.data]);
    });
}, []);

const modules = util.getModules();
const isSuper  = localStorage.getItem('is_admin')        === '1'
              || localStorage.getItem('is_national')     === '1'
              || localStorage.getItem('is_client_admin') === '1';
const tabItems = [
    { k: 'Medical', v: 'Med Assets', cat_type: 'Med/NonMed', asset_cat_id: '3' },
    { k: 'Non Medical', v: 'Non Med Assets', cat_type: 'Med/NonMed', asset_cat_id: '2' },
    { k: 'Vehicle', v: 'Vehicle', cat_type: 'Med/NonMed', asset_cat_id: '8' },
    { k: 'Supplies', v: 'Supplies', cat_type: 'Med/NonMed', asset_cat_id: '9' },
    { k: 'Baselines', v: 'Asset Gaps Analytics', component: 'baseline' }
];

const filteredItems = isSuper ? tabItems : tabItems.filter(item => {
    if (item.k === 'Medical'     && modules.medical             === 1) return true;
    if (item.k === 'Non Medical' && modules.non_medical         === 1) return true;
    if (item.k === 'Vehicle'     && modules.vehicle             === 1) return true;
    if (item.k === 'Supplies'    && modules.supplies            === 1) return true;
    if (item.k === 'Baselines'   && modules.baseline_management === 1) return true;
    return false;
});
      const [tab, setTab] = useState(filteredItems.length > 0 ? filteredItems[0].k : '');

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto">
                    <h2>Assets Capturing</h2>
                </div>
                <div className="my-auto ml-auto"></div>
            </div>

            <div className="page-pad">
         <Tabs
    activeKey={tab}
    destroyInactiveTabPane
    onChange={onTabChange}
    items={filteredItems.map(rw => ({
        key: rw.k,
        label: rw.v,
        children: rw.k === 'Baselines' ? (
            <BaselineManagement
                clients={clients}
                stationPoints={stationPoints}
                items={items}
                isVisible={true}
            />
        ) : (
            <List
                items={items}
                stationPoints={stationPoints}
                functionalStatus={functionalStatus}
                cat_type={rw.cat_type}
                cat={rw.k}
                asset_cat_id={rw.asset_cat_id}
                clients={clients}
            />
        )
    }))}
/>       {}
            </div>
        </div>
    )
    
}

function List(props) {
    const [result, setResult] = useState({ data: [], page: {} });
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef = useRef();
    const transferFormRef = useRef();
    const [clients, setClients] = useState([]);
    const [items, setItems] = useState([]);
    const [stationPoints, setStationPoints] = useState([]);
    const [functionalStatus, setFunctionalStatus] = useState([]);
    const [checkbox, setCheckbox] = useState([]);
    const isNational = util.isNational();
    const [hasSearched, setHasSearched] = useState(false);
    const modules = util.getModules();
    const isSuper = localStorage.getItem('is_admin')        === '1'
                 || localStorage.getItem('is_national')     === '1'
                 || localStorage.getItem('is_client_admin') === '1';

    // ── PATCH STEP 1: verification filter state ──────────────────────────────
    const [verificationFilter, setVerificationFilter] = useState('all'); // 'all'|'verified'|'pending'|'not_found'
    const [verificationProgress, setVerificationProgress] = useState(null);
    const [verifyVehicle, setVerifyVehicle] = useState(null); // vehicle being verified
    const [driverMap,  setDriverMap]  = useState({});  // { vehicle_id → driver_name }
    const [flagMap,    setFlagMap]    = useState({});  // { vehicle_id → { has_open_incident, service_due_flag } }
    const [serviceMap, setServiceMap] = useState({});  // { vehicle_id → { last_service_date, next_service_km, service_due_flag } }
    const [deployMap, setDeployMap] = useState({});  // { vehicle_id → { type, event, is_international } }
    // ─────────────────────────────────────────────────────────────────────────

    const list = (p, ps, vFilter) => {
        setHasSearched(true);
        sdataRef.current.p = p || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        sdataRef.current.cat_type = props.cat_type;
        sdataRef.current.cat = props.cat;
        sdataRef.current.asset_cat_id = props.asset_cat_id;

        // my_assets filter — send 1 if user selected "My Assets", remove otherwise
        if (sdataRef.current.my_assets === '1' || sdataRef.current.my_assets === 1) {
            sdataRef.current.my_assets = 1;
        } else {
            delete sdataRef.current.my_assets;
        }

        // Use the passed-in filter (from tab click) or fall back to current state
        // vFilter is passed directly to avoid React async state update timing issue
        const activeVFilter = vFilter !== undefined ? vFilter : verificationFilter;

        if (props.asset_cat_id === '8' && activeVFilter !== 'all') {
            sdataRef.current.verification_status = activeVFilter;
        } else {
            delete sdataRef.current.verification_status;
        }

        util.showLoader();
        AssetService.lists(sdataRef.current).then(({ data }) => {
            // Filter by asset category
            let filteredData = data.result.data.filter(
                item => item.asset_cat_id === props.asset_cat_id
            );

            // Client-side verification filter — reliable even if backend ignores the param
            if (props.asset_cat_id === '8' && activeVFilter !== 'all') {
                filteredData = filteredData.filter(
                    item => item.verification_status === activeVFilter
                );
            }

            // Client-side "My Assets" filter — filter by current user's created_by ID
            if (sdataRef.current.my_assets === '1') {
                // Try multiple ways to get current user ID
                const myUserId = (
                    (util.getUserId && util.getUserId()) ||
                    (util.getUser && util.getUser()?.id) ||
                    window.USER_ID ||
                    localStorage.getItem('user_id')
                );
                if (myUserId) {
                    filteredData = filteredData.filter(
                        item => String(item.created_by) === String(myUserId)
                    );
                }
            }

            setResult({ ...data.result, data: filteredData });

            // ── PATCH STEP 2: load verification progress for vehicle tab ─────
            if (props.asset_cat_id === '8') {
                AssetService.getVehicleVerificationProgress().then(res => {
                    if (res?.result) setVerificationProgress(res.result);
                }).catch(() => {}); // non-critical

                // Load drivers + service info from vehiclesList in one call
                FleetService.getVehiclesList().then(res => {
                    if (Number(res?.data?.code) === 200 && Array.isArray(res.data.result)) {
                        const dMap = {};
                        const sMap = {};
                        res.data.result.forEach(v => {
                            if (v.current_driver_name) dMap[String(v.id)] = v.current_driver_name;
                            sMap[String(v.id)] = {
                                last_service_date:  v.last_service_date  || null,
                                next_service_km:    v.next_service_km    || null,
                                service_due_flag:   v.service_due_flag   || null,
                                times_deployed:     Number(v.times_deployed     || 0),
                                total_days_deployed:Number(v.total_days_deployed || 0),
                            };
                        });
                        const depMap = {};
                        res.data.result.forEach(v => {
                            if (v.active_deployment) {
                                const parts = v.active_deployment.split('|');
                                depMap[String(v.id)] = {
                                    type: parts[0], event: parts[1],
                                    destination: parts[2], is_international: parts[3] === '1',
                                };
                            }
                        });
                        setDriverMap(dMap);
                        setServiceMap(sMap);
                        setDeployMap(depMap);
                    }
                }).catch(() => {});

                // Build accident flagMap directly from incidents (most reliable)
                FleetService.getIncidents().then(res => {
                    const list = res?.data?.result || [];
                    if (Array.isArray(list)) {
                        const fMap = {};
                        list.forEach(inc => {
                            const isOpen = inc.status === 'Open' || inc.status === 'Under Review'
                                || !inc.date_resolved
                                || inc.date_resolved === '0000-00-00'
                                || inc.date_resolved === '';
                            if (isOpen) {
                                fMap[String(inc.vehicle_id)] = { has_open_incident: 1 };
                            }
                        });
                        setFlagMap(fMap);
                    }
                }).catch(() => {});
            }
            // ─────────────────────────────────────────────────────────────────
            
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });
        
    }

    const filteredStatuses = useMemo(() => {
        return functionalStatus.filter(status => {
            // Exclude these statuses if asset_cat_id is '8'
            if (props.asset_cat_id === '8') {
                // Only these statuses are valid for vehicles
                const allowedFor8 = [
                    'Good condition',
                    'Fair',
                    'Waiting for repairs',
                    'Awaiting for disposal',
                    'TBC'
                ];
                return allowedFor8.includes(status.name);
            }
if (props.asset_cat_id === '9') {
                const excludedFor9 = [
                    'Good condition',
                    'Fair',
                    'Awaiting for disposal',
                    'Waiting for repairs',
                    'Not installed',
                    'Functional',
                    'Boarded',
                    'Non functional',
                    'Installed',
                    'Partial functional'

                ];
                return !excludedFor9.includes(status.name);
            }
            // Exclude these statuses if asset_cat_id is '3' or '2'
            if (props.asset_cat_id === '3' || props.asset_cat_id === '2') {
                const excludedFor3And2 = [
                    'Good condition',
                    'Fair',
                    'Awaiting for disposal',
                    'Waiting for repairs',
                    'Usable',
                    'Expired'
                ];
                return !excludedFor3And2.includes(status.name);
            }

            return true; // Include all other statuses for other asset_cat_id values
        });
    }, [functionalStatus, props.asset_cat_id]);

    const handleCheckbox = (e, id, allSelect = false) => {
        let dt = checkbox;
        if (!allSelect) {
            if (e.target.checked) {
                dt = [...new Set(dt)];
                dt.push(id)
            } else {
                dt.splice(dt.indexOf(id), 1);
                dt = [...new Set(dt)]; 
            }
        } else {
            dt = [];
            if (e.target.checked) {
                result.data.map(v => dt.push(v.id));
            }
        }
        setCheckbox([...dt])
    }

    useEffect(() => {
        setClients(props.clients);
    }, [props.clients]);

useEffect(() => {
    AssetService.allItems({ status: 1, asset_cat_id: props.asset_cat_id}).then(res => {
        let allItems = [];
        allItems = res.data.result.data.map((v) => {
            if (v.asset_cat_id === '8') {
                v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
            } else {
                v.item_full_name = v.item_full_name + ' [' + v.cat + ']';
            }
            return v;
        });
        setItems(allItems);
    });
}, [props.asset_cat_id]); 
    useEffect(() => {
        setStationPoints(props.stationPoints);
    }, [props.stationPoints]);

    useEffect(() => {
        setFunctionalStatus(props.functionalStatus);
    }, [props.functionalStatus]);
useEffect(() => {
    // Only cleanup on unmount, don't auto-load data
    return () => { 
        message.destroy();
    }
}, []);

    return (
        <div className="">
            <div className="">
                <div className="d-flex mb8">
                    <div className="text-secondary my-auto">
                        {result.data.length > 0 &&
                            <div>
                                Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                            </div>
                        }
                    </div>
                    <div className="ml-auto my-auto">
                        {(isSuper || modules['transfer_asset'] === 1) &&
                            <Button size="small" type="danger" className="mr-2" onClick={() => transferFormRef.current.openForm()} disabled={!checkbox.length}>
                                <img src={share} alt='login' className='h-1 mr5'  height={15} /> Transfer
                            </Button>
                        }
                        {props.asset_cat_id === '8' && (
                            <FleetExport buttonStyle={{ marginRight: 8, height: 24, fontSize: 12, padding: '0 10px' }} />
                        )}
                        {(isSuper || modules['add_asset'] === 1) &&
                            <Button size="small" type="primary" onClick={() => formRef.current.openForm()}>
                                <img src={plus} alt='login' className='h-1 mr5' fill="white" height={13} />
                                {props.asset_cat_id === '8' ? 'Add Vehicles' :
                                 props.asset_cat_id === '2' ? 'Add Non-Medical' :
                                 props.asset_cat_id === '3' ? 'Add Medical Assets' :
                                 props.asset_cat_id === '9' ? 'Add Supplies' :
                                 'Add Records'}
                            </Button>
                        }
                    </div>
                </div>

                {/* ── Verification progress bar + filter tabs — ABOVE search form ── */}
                {props.asset_cat_id === '8' && (
                    <div style={{ marginBottom: 12 }}>

                        {/* Progress summary */}
                        {verificationProgress && (
                            <div style={{
                                display: 'flex',
                                gap: 24,
                                padding: '10px 16px',
                                background: '#f5f5f5',
                                borderRadius: 8,
                                marginBottom: 8,
                                fontSize: 13,
                            }}>
                                <span style={{ color: '#666' }}>Fleet verification:</span>
                                <span style={{ color: '#52c41a' }}>
                                    {verificationProgress.verified} verified
                                </span>
                                <span style={{ color: '#faad14' }}>
                                    {verificationProgress.pending} pending
                                </span>
                                <span style={{ color: '#f5222d' }}>
                                    {verificationProgress.not_found} not found
                                </span>
                                {(verificationProgress.found_at_facility || 0) > 0 && (
                                    <span style={{ color: '#722ed1' }}>
                                        {verificationProgress.found_at_facility} found on ground
                                    </span>
                                )}
                                <span style={{ color: '#999', marginLeft: 'auto' }}>
                                    {verificationProgress.total} total
                                </span>
                            </div>
                        )}

                        {/* Filter tabs */}
                        <div style={{ display: 'flex', gap: 8 }}>
                            {[
                                { key: 'all',               label: 'All vehicles' },
                                { key: 'verified',          label: 'Verified & deployed' },
                                { key: 'pending',           label: 'Pending verification' },
                                { key: 'not_found',         label: 'Not found' },
                                { key: 'found_at_facility', label: 'Found at facility' },
                            ].map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => {
                                        setVerificationFilter(tab.key);
                                        list(1, null, tab.key); // pass directly — state update is async
                                    }}
                                    style={{
                                        padding: '5px 14px',
                                        borderRadius: 20,
                                        border: '0.5px solid',
                                        borderColor: verificationFilter === tab.key ? '#1890ff' : '#d9d9d9',
                                        background: verificationFilter === tab.key ? '#e6f7ff' : 'transparent',
                                        color: verificationFilter === tab.key ? '#1890ff' : '#666',
                                        cursor: 'pointer',
                                        fontSize: 13,
                                    }}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
                {/* ─────────────────────────────────────────────────────────── */}

                <div className="tbl-search-head">
                    <SearchForm
                        dataRef={sdataRef}
                        clients={clients}
                        functionalStatus={filteredStatuses}
                        stationPoints={stationPoints}
                        cat_type={props.cat_type}
                        isNational={isNational}
                        asset_cat_id={props.asset_cat_id}
                        onSearch={list}
                    />
                </div>

                <If cond={result.data.length}>
    <div className="table-responsive">
        <table className="table table-bordered table-sm font-xs table-striped table-hover m-0">
            <thead className="thead-light text-uppercase table-text-vmid pad-y-md">
                <tr>
                    <th className="w20">
                        <input type="checkbox" checked={(() => {
                            let flag = true;
                            result.data.forEach(v => {
                                if (!checkbox.includes(v.id)) {
                                    flag = false;
                                }
                            });
                            return flag;
                        })()}
                        onChange={(e) => handleCheckbox(e, 0, true)}
                        />
                    </th>
                    {isNational === 1 && <th className="w100">Facility</th>}
                    {props.asset_cat_id === '9' &&
                        <> 
                        
                        <th className="w100 nowrap">Batch number</th>
                        </>
                    }
                    {props.asset_cat_id === '8' &&
                        <> 
                        
                        <th className="w100 nowrap">Registration plate</th>
                        </>
                    }
                    {props.asset_cat_id === '2' &&
                        <> 
                        
                        <th className="w100 nowrap">Tag number</th>
                        </>
                    }
                    {props.asset_cat_id === '3' &&
                        <> 
                        
                        <th className="w100 nowrap">serial number</th>
                        </>
                    }
                    <th>Asset Name</th>
                   {props.asset_cat_id === '8' &&
                        <>
                        <th className="w100">Engine No</th>
                        <th className="w100">Chassis</th>
                        <th className="w100">Mileage</th>
                        </>
                    }
                    {props.asset_cat_id === '2' &&
                        <> 
                        
                        <th className="w100 nowrap">Received Year</th>
                        </>
                    }<th className="w100 nowrap">RECORD INFO</th>
                          {props.asset_cat_id !== '8' && <th className="w100">Quantity</th>}
                          {props.asset_cat_id === '8' &&
                        <><th className="w100 text-left">Required Maintenance</th></> }
                           <th className="w100 text-left">Remarks</th>
                            <th className="w100">Location</th>
                            <th className="w130">Status</th>
                            {/* ── PATCH STEP 5: verification column header ── */}
                            {props.asset_cat_id === '8' && (
                                <th className="w130">
                                    Verification
                                    <div style={{ fontSize: 10, fontWeight: 400, color: '#888' }}>status / updated by</div>
                                </th>
                            )}
                            {/* ──────────────────────────────────────────── */}
                            <th className="w130">Source</th>
                            <th className="w100">Photos</th>
                            <th className="w20"></th>
                </tr>
            </thead>

            <tbody className="table-text-top font-sm">
                {result.data.sort((a, b) => {
                    // Sort by item
                              return b.id - a.id;
                }).map((v, i) => {
                    let backgroundColor;
                    switch (v.functional_status_name) {
                        case 'Fair':
                            backgroundColor = 'orange';
                            break;
                        case 'Good condition':
                            backgroundColor = 'green';
                            break;
                            case 'Usable':
                            backgroundColor = 'green';
                            break;
                        case 'Waiting for repairs':
                            backgroundColor = 'red';
                            break;
                            case 'Expired':
                            backgroundColor = 'red';
                            break;
                        case 'Awaiting for disposal':
                            backgroundColor = 'black';
                            break;
                        case 'Not installed':
                            backgroundColor = 'brown';
                            break;
                        case 'Serviceable':
                            backgroundColor = 'green';
                            break;
                        case 'Unserviceable':
                            backgroundColor = 'red';
                            break;
                        case 'Boarded':
                            backgroundColor = 'black';
                            break;
                            case 'Installed':
                            backgroundColor = 'blue';
                            break;
                        case 'Partial functional':
                            backgroundColor = 'yellow';
                            break;
                        

                    }                   
function calculateMaturityDate(installationDate, lifespanValue) {
        const date = new Date(installationDate);
        const lifespanYears = parseInt(lifespanValue, 10); // Ensure lifespanValue is an integer
        date.setFullYear(date.getFullYear() + lifespanYears);
    
        // Format date as DD MMM YYYY
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
    }
    
function calculateRemainingYears(installationDate, lifespanValue) {
        const maturityDate = new Date(installationDate);
        const lifespanYears = parseInt(lifespanValue, 10); // Ensure lifespanValue is an integer
        maturityDate.setFullYear(maturityDate.getFullYear() + lifespanYears);
    
        const currentDate = new Date();
        const remainingYears = maturityDate.getFullYear() - currentDate.getFullYear();
        return remainingYears;
    }
    
function calculateRemainingMonths(installationDate, lifespanValue) {
        const maturityDate = new Date(installationDate);
        const lifespanYears = parseInt(lifespanValue, 10); // Ensure lifespanValue is an integer
        maturityDate.setFullYear(maturityDate.getFullYear() + lifespanYears);
    
        const currentDate = new Date();
        const remainingMonths = (maturityDate.getFullYear() - currentDate.getFullYear()) * 12 + (maturityDate.getMonth() - currentDate.getMonth());
        return remainingMonths;
    }
                    return (

                        
    
                        <tr key={i}>
                            <td>
                                <input type="checkbox" checked={checkbox.includes(v.id) ? true : false} onChange={(e) => handleCheckbox(e, v.id)} />
                            </td>
                            {isNational === 1 && 
                            <td>
                                {v.client} <div style={{ marginTop: '4px', color: 'green', fontWeight: 900 }}>SITE CODE:
                                {v.site_code}   </div> 
                            </td>
                            }
                            <td>
                                {props.asset_cat_id === '9' &&
                        <> 
                        
                        {v.eibatchnumber}
                        </>
                    }
                                {props.asset_cat_id === '8' &&
                        <> 
                        
                        {v.serial_no}
                        {/* ── Inline document pills ── */}
                        <VehicleDocInline
                            vehicleId={v.id}
                            clientId={v.client_id}
                            serialNo={v.serial_no}
                        />
                        </>
                    }           
           {props.asset_cat_id === '3' &&
                        <> 
                        
                        {v.serial_no}
                        </>
                    }
                               {props.asset_cat_id === '2' &&
                        <> 
                        
                        {v.serial_no}
                        </>
                    }

                                {v.isdonated === 1 &&
                                    <div style={{ marginTop: '4px', color: 'purple', fontWeight: 700 }}>Donated</div>
                                }
                            </td>
                            <td>
                                <div className="uc bold700">{v.item}</div>
                                <div className="pt3 note-text">
                                {/*     <div className="d-flex"><div className="w90">Model</div> : <div className="bold600 pl5">{v.model}</div></div>*/}
                                  {v.asset_cat_id ==='8' && v.eimonth && <div className="d-flex"><div className="w90">Model</div> : <div className="bold600 pl5">{v.eimonth}</div></div>}
                                   
                 {/* Vehicle-specific information section */}
{/* Service interval display */}
{/* {props.cat === 'Vehicle' &&<div className="d-flex"><div className="w90">Service</div> : <div className="bold600 pl5">Every {v.service_period} {v.service_period_type}</div></div>} */}

{/* Asset lifespan information */}
{/* {props.cat === 'Vehicle' &&<div className="d-flex"><div className="w90">Life Span</div> : <div className="bold600 pl5">{v.lifespanvalue} {v.lifespanunit}</div></div>} */}

{/* Calculated maturity date */}
{/* {props.cat === 'Vehicle' &&<div className="d-flex"><div className="w90">Maturity Date</div> : <div className="bold600 pl5">{calculateMaturityDate(v.installation_date,v.lifespanvalue)}</div></div>} */}

{/* Remaining time calculation in years and months */}
{/* {props.cat === 'Vehicle' &&<div className="d-flex"><div className="w90">Remaining Time</div> : <div className="bold600 pl5">{calculateRemainingYears(v.installation_date,v.lifespanvalue)} Years or {calculateRemainingMonths(v.installation_date,v.lifespanvalue)} Months</div></div>} */}
                                    {v.subcat &&
                                        <div className="d-flex"><div className="w90">Type</div> : <div className="bold600 pl5">{v.subcat}</div></div>
                                    }
                                    {v.asset_cat_id === '8' && v.model &&
                                        <div className="d-flex"><div className="w90">Model</div> : <div className="bold600 pl5">{v.model}</div></div>
                                    }
                                    </div>

                                    {/* ── Verify / Re-verify button — always shown for vehicles ── */}
                                    {props.asset_cat_id === '8' && (
                                        <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                            <Button
                                                type="primary"
                                                size="small"
                                                title={
                                                    v.verification_status === 'pending'          ? 'Verify vehicle on ground' :
                                                    v.verification_status === 'not_found'        ? 'Re-verify vehicle' :
                                                    v.verification_status === 'verified'         ? 'Re-verify this vehicle again' :
                                                    v.verification_status === 'found_at_facility'? 'Re-verify this vehicle again' :
                                                    'Verify vehicle'
                                                }
                                                style={{
                                                    background:
                                                        v.verification_status === 'pending'           ? '#389e0d' :
                                                        v.verification_status === 'not_found'         ? '#d46b08' :
                                                        v.verification_status === 'verified'          ? '#1677ff' :
                                                        v.verification_status === 'found_at_facility' ? '#722ed1' :
                                                        '#389e0d',
                                                    borderColor:
                                                        v.verification_status === 'pending'           ? '#389e0d' :
                                                        v.verification_status === 'not_found'         ? '#d46b08' :
                                                        v.verification_status === 'verified'          ? '#1677ff' :
                                                        v.verification_status === 'found_at_facility' ? '#722ed1' :
                                                        '#389e0d',
                                                    fontSize: 12,
                                                }}
                                                onClick={() => setVerifyVehicle(v)}
                                            >
                                                {
                                                    v.verification_status === 'pending'           ? '✓ Verify' :
                                                    v.verification_status === 'not_found'         ? '↩ Re-verify' :
                                                    v.verification_status === 'verified'          ? '↩ Re-verify' :
                                                    v.verification_status === 'found_at_facility' ? '↩ Re-verify' :
                                                    '✓ Verify'
                                                }
                                            </Button>
                                            {/* Verification count badge */}
                                            {v.verification_count > 0 && (
                                                <span style={{
                                                    fontSize: 10,
                                                    color: '#888',
                                                    background: '#f0f0f0',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: 10,
                                                    padding: '1px 7px',
                                                    whiteSpace: 'nowrap',
                                                }}>
                                                    {v.verification_count}× verified
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {/* ─────────────────────────────────────────────────────── */}

                                    {/* ── Vehicle flags ── */}
                                    {props.asset_cat_id === '8' && (flagMap[String(v.id)]?.has_open_incident || serviceMap[String(v.id)]?.service_due_flag) && (
                                        <div style={{ display: 'flex', gap: 5, marginTop: 5, flexWrap: 'wrap' }}>
                                            {flagMap[String(v.id)]?.has_open_incident === 1 && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: '1px 7px',
                                                    borderRadius: 10, background: '#fff1f0',
                                                    border: '1px solid #ffa39e', color: '#cf1322',
                                                }}>⚠ ACCIDENT</span>
                                            )}
                                            {serviceMap[String(v.id)]?.service_due_flag === 'overdue' && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: '1px 7px',
                                                    borderRadius: 10, background: '#fff1f0',
                                                    border: '1px solid #ffa39e', color: '#cf1322',
                                                }}>🔧 SERVICE OVERDUE</span>
                                            )}
                                            {serviceMap[String(v.id)]?.service_due_flag === 'due_soon' && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: '1px 7px',
                                                    borderRadius: 10, background: '#fffbe6',
                                                    border: '1px solid #ffe58f', color: '#d48806',
                                                }}>🔧 SERVICE DUE &lt;500km</span>
                                            )}
                                            {deployMap[String(v.id)] && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: '1px 7px',
                                                    borderRadius: 10,
                                                    background: deployMap[String(v.id)].is_international ? '#f9f0ff' : '#fff7e6',
                                                    border: `1px solid ${deployMap[String(v.id)].is_international ? '#d3adf7' : '#ffd591'}`,
                                                    color: deployMap[String(v.id)].is_international ? '#722ed1' : '#d46b08',
                                                }}>
                                                    {deployMap[String(v.id)].is_international ? '🌍 OUT OF COUNTRY' : '🚩 ON DEPLOYMENT'}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* ── Status History ── */}
                                    {props.asset_cat_id === '8' && (
                                        <StatusHistoryButton assetId={v.id} regNo={v.registration_no || v.serial_no} />
                                    )}

                                    {/* ── Assigned driver ── */}
                                    {props.asset_cat_id === '8' && (
                                        <div style={{ marginTop: 5, display: 'flex', alignItems: 'center', gap: 5 }}>
                                            <span style={{ fontSize: 11, color: '#888' }}>👤 Driver:</span>
                                            <span style={{
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: driverMap[String(v.id)] ? '#1677ff' : '#bbb',
                                            }}>
                                                {driverMap[String(v.id)] || 'Unassigned'}
                                            </span>
                                        </div>
                                    )}

                                    {/* ── Fleet detail grid (always visible) ── */}
                                    {props.asset_cat_id === '8' && (
                                        <div style={{
                                            marginTop: 8,
                                            padding: '6px 8px',
                                            background: '#fafafa',
                                            border: '1px solid #e8e8e8',
                                            borderRadius: 5,
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '3px 12px',
                                            fontSize: 11,
                                        }}>
                                            {[
                                                ['Region',      v.region],
                                                ['Programme',   v.assigned_programme],
                                                ['Old Reg',     v.private_ref_old_reg],
                                                ['Engine (cc)', v.engine_capacity_cc],
                                                ['Colour',      v.colour],
                                                ['Condition',   v.condition_rating ? `${v.condition_rating}/5` : null],
                                                ['Fuel Type',   v.fuel_type],
                                                ['Procurement', v.procurement_method],
                                                ['Funder',      v.funded_by],
                                                ['Last Serviced', serviceMap[String(v.id)]?.last_service_date && serviceMap[String(v.id)]?.last_service_date !== '0000-00-00'
                                                    ? new Date(serviceMap[String(v.id)].last_service_date).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' })
                                                    : null],
                                                ['Next Svc (km)', serviceMap[String(v.id)]?.next_service_km
                                                    ? Number(serviceMap[String(v.id)].next_service_km).toLocaleString() + ' km'
                                                    : null],
                                                ['Times Deployed', serviceMap[String(v.id)]?.times_deployed
                                                    ? `${serviceMap[String(v.id)].times_deployed} trip${serviceMap[String(v.id)].times_deployed !== 1 ? 's' : ''}`
                                                    : null],
                                                ['Days Out', serviceMap[String(v.id)]?.total_days_deployed
                                                    ? `${serviceMap[String(v.id)].total_days_deployed} days total`
                                                    : null],
                                            ].map(([label, val]) => (
                                                <div key={label} style={{ display: 'flex', gap: 3 }}>
                                                    <span style={{ color: '#aaa', whiteSpace: 'nowrap' }}>{label}:</span>
                                                    <span style={{ fontWeight: 500, color: val ? '#333' : '#ccc' }}>
                                                        {val || '—'}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {/* ──────────────────────────────────────────────────────── */}
                            </td>
                            {props.asset_cat_id === '8' &&
                            <td>{v.eieftnumber}</td>}

                            {props.asset_cat_id === '8' &&
                            <td>{v.order_number}</td>}

                            {props.asset_cat_id === '8' &&
                                <td>
                                  {v.delivery_note_number}KM
                                  
                                    <div>Recorded date: {v.created}</div>
                                </td>
                            }
                            
                             {props.asset_cat_id === '2' &&
                                    <td>{v.procurement_date ? (String(v.procurement_date).length <= 4 ? v.procurement_date : moment(v.procurement_date).format('YYYY')) : ''}</td>
                             }
                             
                                <td className="text-right">
                                  <div> CREATED ON: {v.created}</div>
                                    <div>BY USER_ID:{v.created_by}</div>
                                </td>
                            
                                    {props.asset_cat_id !== '8' && <td className="text-right">{v.stock}</td>}
                             
                              {props.asset_cat_id === '8' &&   <td className="text-left">{v.eistatus}</td>}
                            <td className="text-left">{v.eicomment} </td>
                            
                                    <td>
                                        {v.station_points.map((s, j) => (
                                            <div className="note-text" key={j}>
                                                {s.station_point}
                                            </div>
                                        ))}
                                    </td>
                                    <td  style={{ backgroundColor }}>{v.functional_status_name}</td>

                                    {/* Verification status + last updated by/when */}
                                    {props.asset_cat_id === '8' && (
                                        <td style={{ minWidth: 130 }}>
                                            {(() => {
                                                const statusMap = {
                                                    pending:            { color: 'orange', text: 'Pending' },
                                                    verified:           { color: 'green',  text: 'Verified' },
                                                    not_found:          { color: 'red',    text: 'Not found' },
                                                    found_at_facility:  { color: 'purple', text: 'Found at facility' },
                                                };
                                                const s = statusMap[v.verification_status] || { color: 'default', text: v.verification_status || 'Pending' };
                                                // Use updated + updated_by_name for last action info
                                                const actionDate = v.updated || v.verified_at;
                                                const actionBy   = v.updated_by_name || v.verified_by_name;
                                                return (
                                                    <div>
                                                        <Tag color={s.color}>{s.text}</Tag>
                                                        {actionDate && (
                                                            <div style={{ fontSize: 11, color: '#888', marginTop: 4, lineHeight: 1.5 }}>
                                                                <div style={{ fontWeight: 500, color: '#555' }}>
                                                                    {actionBy || 'Unknown'}
                                                                </div>
                                                                <div>
                                                                    {actionDate.toString().split(' ')[0]}
                                                                    {actionDate.toString().split(' ')[1] && (
                                                                        <span style={{ color: '#aaa', marginLeft: 4 }}>
                                                                            {actionDate.toString().split(' ')[1].substring(0, 5)}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                    )}
                                    {/* ────────────────────────────────────────── */}

                                    <td>
                                        {v.data_source === 'excel_import' ? (
                                            <span style={{ fontSize: 11, color: '#1890ff', fontWeight: 500 }}>📥 Imported</span>
                                        ) : v.data_source === 'ground_verification' ? (
                                            <span style={{ fontSize: 11, color: '#722ed1', fontWeight: 500 }}>🔍 Found on ground</span>
                                        ) : v.data_source ? (
                                            <span style={{ fontSize: 11, color: '#666' }}>{v.data_source}</span>
                                        ) : (
                                            <span style={{ fontSize: 11, color: '#999' }}>Manual</span>
                                        )}
                                    </td>
                             <td>
                                 

    <PhotoViewer 
        assetId={v.id}
        photos={v.photos}
        onManagePhotos={(assetId) => {
            const asset = result.data.find(a => a.id === assetId);
            if (asset) {
                formRef.current.openForm(asset);
            }
        }}
    />
</td>
                            <td className="text-center">
                                <Button.Group size="small">
                                    <Button type="default" onClick={() => formRef.current.openForm(v)}>
                                        <img src={pen} alt='edit' className='h-1 mr5' height={15} />
                                    </Button>

                                </Button.Group>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
    <div className="d-flex tbl-foot-bx">
        <AntdPaging
            onChange={list}
            total={result.page.total_records}
            current={result.page.cur_page}
            pageSize={sdataRef.current.ps}
            showSizeChanger
        />
    </div>
</If>
<If cond={!result.data.length}>
    <div className="no-rec">Click the search button to load data</div>
</If>
            </div>

            <VerifyVehicleModal
                vehicle={verifyVehicle}
                clients={clients}
                stationPoints={stationPoints}
                functionalStatus={functionalStatus}
                onDone={() => { setVerifyVehicle(null); list(sdataRef.current.p); }}
                onClose={() => setVerifyVehicle(null)}
            />

            <AddForm
             ref={formRef}
                pageno={sdataRef.current.p}
                clients={clients}
                
                items={items}
                stationPoints={stationPoints}
                functionalStatus={filteredStatuses}
                cat_type={props.cat_type}
                asset_cat_id={props.asset_cat_id}
                isNational={isNational}
                callback={list}
            />

            <TransferForm ref={transferFormRef} {...{
                checkbox,
                clients: props.clients,
                resultData: result.data.map((v) => { return { id: v.id, item: v.item, cat: v.cat, subcat: v.subcat, serial_no: v.serial_no, stock: v.stock, client: v.client } }),
                callback: list,
                pageno: sdataRef.current.p,
                cat_type: props.cat_type,
                modules,
            }} />
        </div>
    )
}
const SearchForm = (props) => {
    let { dataRef, onSearch, clients, functionalStatus, isNational, cat_type, asset_cat_id } = props;
    let [data, setData] = useState({ ...dataRef.current, station_point_ids: [], isdonated: null, verification_status: 'pending', data_source: '', eieftnumber: '' });
    let [stationPoints, setStationPoints] = useState([]);
    const [items, setItems] = useState([]);

    const filteredStatuses = useMemo(() => {
        return functionalStatus.filter(status => {
            if (props.asset_cat_id === '8') {
                const excludedFor8 = [
                    'Not installed', 
                    'Functional', 
                    'Boarded', 
                    'Non functional', 
                    'Installed', 
                    'Partial functional',
                    'Usable',
                    'Expired'
                ];
                return !excludedFor8.includes(status.name);
            }
            if (props.asset_cat_id === '9') {
                const excludedFor9 = [
                    'Good condition',
                    'Fair',
                    'Awaiting for disposal',
                    'Waiting for repairs',
                    'Not installed',
                    'Functional',
                    'Boarded',
                    'Non functional',
                    'Installed',
                    'Partial functional'
                ];
                return !excludedFor9.includes(status.name);
            }
            if (props.asset_cat_id === '3' || props.asset_cat_id === '2') {
                const excludedFor3And2 = [
                    'Good condition',
                    'Fair',
                    'Awaiting for disposal',
                    'Waiting for repairs',
                    'Usable',
                    'Expired'
                ];
                return !excludedFor3And2.includes(status.name);
            }
            
            return true;
        });
    }, [functionalStatus, props.asset_cat_id]);

    const handleChange = (v, k) => {
        data[k] = v;
        if (k === 'client_id') {
            data.station_point_ids = [];
        }
        setData({ ...data });
    }

    // Removed stale localStorage filter preference logic

    useEffect(() => {
        dataRef.current = { ...data };
    }, [data]);

    useEffect(() => {
        if (isNational === 1) {
            setData({ ...data, client_id: null });
        } else {
            let ob = clients.find(v => v.is_me);
            setData({ ...data, client_id: ob?.id });
        }
    }, [clients]);

    useEffect(() => {
        setStationPoints([...props.stationPoints]);
    }, [props.stationPoints]);

    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);

    useEffect(() => {
        AssetService.allItems({ status: 1, cat_type, asset_cat_id, client_id: data.client_id, availableAssetsOnly: 'Y' }).then(res => {
            let allItems = [];
            allItems = res.data.result.data.map((v) => {
                if (v.cat_type === 'Med/NonMed') {
                    v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
                } else {
                    v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
                }
                return v;
            });
            setItems(allItems);
        });
    }, [cat_type, data.client_id]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                
                {/* User Assets Filter - ADD THIS AS FIRST ELEMENT */}
                <div className="w180 mr5">
                    <div className="text-secondary fs11 mb2">Assets Filter</div>
                    <AntdSelect
                        placeholder="All Assets"
                        allowClear
                        options={[
                            { value: '1', label: 'My Assets' },
                        ]}
                        value={data.my_assets}
                        onChange={v => handleChange(v, 'my_assets')}
                    />
                </div>
                
                {isNational === 1 && (
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Level</div>
                        <AntdSelect
                            options={[
                                
                                { value: 'Level 2', label: "Level 2" },
                                { value: 'Level 3', label: "Level 3" },
                                { value: 'Level 4', label: "Level 4" },
                                { value: 'Level 5', label: "Level 5" }
                            ]}
                            allowClear
                            value={data.site_type}
                            onChange={v => { handleChange(v, 'site_type') }}
                        />
                    </div>
                )}
                {isNational === 1 &&
                    <div className="w350 mr5">
                        <div className="text-secondary fs11 mb2">Facility</div>
                        <AntdSelect
                            placeholder="Select Facility"
                            allowClear
                            showSearch
                            options={clients}
                            value={data.client_id}
                            onChange={v => {
                                data.item_id = null;
                                handleChange(v, 'client_id');
                            }}
                        />
                    </div>
                }
                {props.asset_cat_id === '9' &&
                    <div className="w170 mr5">
                        <div className="text-secondary fs11 mb2">Status</div>
                        <AntdSelect
                            placeholder="All Status"
                            allowClear
                            showSearch
                            options={filteredStatuses}
                            value={data.functional_status}
                            onChange={v => handleChange(v, 'functional_status')}
                        />
                    </div>
                }
                {props.asset_cat_id === '8' &&
                    <div className="w170 mr5">
                        <div className="text-secondary fs11 mb2">Vehicle Status</div>
                        <AntdSelect
                            placeholder="All Status"
                            allowClear
                            showSearch
                            options={filteredStatuses}
                            value={data.functional_status}
                            onChange={v => handleChange(v, 'functional_status')}
                        />
                    </div>
                }
                {props.asset_cat_id === '3' &&
                    <div className="w170 mr5">
                        <div className="text-secondary fs11 mb2">Functional Status</div>
                        <AntdSelect
                            placeholder="All Status"
                            allowClear
                            showSearch
                            options={filteredStatuses}
                            value={data.functional_status}
                            onChange={v => handleChange(v, 'functional_status')}
                        />
                    </div>
                }
                {props.asset_cat_id === '2' &&
                    <div className="w170 mr5">
                        <div className="text-secondary fs11 mb2">Status</div>
                        <AntdSelect
                            placeholder="All Status"
                            allowClear
                            showSearch
                            options={filteredStatuses}
                            value={data.functional_status}
                            onChange={v => handleChange(v, 'functional_status')}
                        />
                    </div>
                }
                <div className="w350 mr5">
                    <div className="text-secondary fs11 mb2">Asset Name</div>
                    <AntdSelect
                        placeholder="Assets (All)"
                        allowClear
                        showSearch
                        options={items.map(v => { return { id: v.id, name: v.item_full_name } })}
                        value={data.item_id}
                        onChange={v => handleChange(v, 'item_id')}
                    />
                </div>
                {props.asset_cat_id === '8' &&
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Registration</div>
                        <Input placeholder="Number Plate" 
                            allowClear value={data.serial_no}
                            onChange={e => handleChange(e.target.value, 'serial_no')} />
                    </div>
                }

                {props.asset_cat_id === '9' &&
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Batch Number</div>
                        <Input placeholder="Batch Number" 
                            allowClear value={data.eibatchnumber}
                            onChange={e => handleChange(e.target.value, 'eibatchnumber')} />
                    </div>
                }

                {props.asset_cat_id === '3' &&
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Identifier</div>
                        <Input placeholder="Identifier" 
                            allowClear value={data.serial_no}
                            onChange={e => handleChange(e.target.value, 'serial_no')} />
                    </div>
                }

                {props.asset_cat_id === '2' &&
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Tag Number</div>
                        <Input placeholder="Tag" 
                            allowClear value={data.serial_no}
                            onChange={e => handleChange(e.target.value, 'serial_no')} />
                    </div>
                }

                {props.asset_cat_id === '8' &&
                    <div className="w210 mr5">
                        <div className="text-secondary fs11 mb2">Chassis Number</div>
                        <Input placeholder="Chassis Number" 
                            allowClear value={data.order_number}
                            onChange={e => handleChange(e.target.value, 'order_number')} />
                    </div>
                }

                {props.asset_cat_id === '9' &&
                    <div className="w130 mr5">
                        <div className="text-secondary fs11 mb2">From Date</div>
                        <AntdDatepicker
                            placeholder="From Date"
                            allowClear
                            value={data.from}
                            onChange={v => {
                                if (data.to && moment(v) > moment(data.to)) {
                                    message.error("From date should be less than or equal to To Date");
                                    v = null;
                                }
                                handleChange(v, 'from');
                            }}
                        />
                    </div>
                }

                {props.asset_cat_id === '9' &&
                    <div className="w130 mr5">
                        <div className="text-secondary fs11 mb2">To Date</div>
                        <AntdDatepicker
                            placeholder="To Date"
                            allowClear
                            value={data.to}
                            onChange={v => {
                                if (data.from && moment(v) < moment(data.from)) {
                                    message.error("To date should be greater than or equal to From Date");
                                    v = null;
                                }
                                handleChange(v, 'to');
                            }}
                        />
                    </div>
                }
    
                <div className="w210 mr5">
                    <div className="text-secondary fs11 mb2">Donated?</div>
                    <div style={{ width: 90 }}>
                        <AntdSelect
                            allowClear
                            placeholder="All"
                            options={[{ label: 'No', value: '0' }, { label: 'Yes', value: '1' }]}
                            value={data.isdonated}
                            onChange={v => handleChange(v, 'isdonated')}
                        />
                    </div>
                </div>

                <div className="pt15">
                    <Button className="mt4" type="primary" onClick={() => onSearch()}>
                        <img src={search} alt='search' className='h-1 mr5' height={15} />
                    </Button>
                </div>
            </div>
        </form>
    )
}
const TransferForm = forwardRef((props, ref) => {
    let {checkbox, clients, resultData, callback, pageno, cat_type, modules } = props;
    const [showForm, setShowForm] = useState(false);
    let [assetIdQtys, setAssetIdQtys] = useState([]);
    let [clientId, setClientId] = useState(null);
    let [TR38, setTR38] = useState('');
    
    let [reason, setReason] = useState('');

    const isNational = util.isNational();
    const handleChange = (value, id) => {
        let dt = assetIdQtys;
        dt[id] = value;
        setAssetIdQtys({ ...dt });
    }

    const save = (approve) => {
        message.destroy();
        util.showLoader();
        AssetService.transferAsset({
            transfer_to: clientId,
            reason,
            TR38,
            approve,
            asset_ids: (() => {
                let dt = [];
                for (const [key, value] of Object.entries(assetIdQtys)) {
                    dt.push({ id: key, qty: value })
                }
                return dt;
            })()
        }).then(({ data }) => {
            message.success(data.message || 'Saved');
            callback(pageno);
            setShowForm(false);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }

    const closeForm = () => {
        setShowForm(false);
    }

    useImperativeHandle(ref, () => ({
        openForm() {
            let dt = {};
            checkbox.forEach(v => {
                dt[v] = cat_type === 'Med/NonMed' ? 1 : ''
            });
            setAssetIdQtys({ ...dt });
            setClientId(null);
            setShowForm(true);
            setReason('');
        }
    }));
    
    return (
        <Modal
            title={`Transfer Asset`}
            open={showForm}
            onCancel={closeForm}
            destroyOnClose
            maskClosable={false}
            width={1100}
            footer={[
                <Button key="1" onClick={closeForm}>Cancel</Button>,
                <Button key="2" type="primary" onClick={() => save('0')}>Transfer</Button>,
                <If cond={modules['approve_transfer_asset']}>
                    <Button key="3" type="danger" onClick={() => save('1')}>Transfer &amp; Approve</Button>
                </If>
            ]}
        >
            <form onSubmit={e => { e.preventDefault(); save() }} autoComplete="off" spellCheck="false">
                <div className="">
                    <div className="row mingap">
                        <div className="col-md-12 form-group">
                            <label className="req">Transfer To</label>
                            <AntdSelect showSearch 
                            options={clients.filter(v => v.is_me === 0)} 
                            value={clientId} onChange={v => setClientId(v)} />
                        </div>

                                <div className="col-md-12 form-group">
                                    <label className="">TR38  Number</label>
                                    <Input.TextArea rows={1}value={TR38} 
                                    onChange={(e) =>setTR38(e.target.value)} />
                                </div>


                    </div>
                    <table className="table table-bordered table-sm font-sm table-striped table-hover">
                        <thead className="thead-light text-uppercase table-text-vmid">
                            <tr>
                                {isNational === 1 && <th className="w100">Facility</th>}
                                <th className="w100">Category</th>
                                <th className="w100">Sub Category</th>
                                <th className="w80">Registration</th>
                                <th>Item/Make</th>
                                <th className="w120 nowrap">Transfer Quantity</th>
                            </tr>
                        </thead>

                        <tbody className="table-text-top">
                            {resultData.map(v => (
                                <React.Fragment key={v.id}>
                                    {checkbox.includes(v.id) &&
                                        <tr>
                                            {isNational === 1 && <td>{v.client}</td>}
                                            <td>{v.cat}</td>
                                            <td>{v.subcat}</td>
                                            <td>{v.serial_no}</td>
                                            <td>
                                                {v.item}
                                                <div className="note-text">
                                                    Available Stock: <strong>{v.stock}</strong>
                                                </div>
                                            </td>
                                            <td>
                                                <Input type="text" value={assetIdQtys[v.id]} onChange={(e) => handleChange(e.target.value, v.id)} disabled={cat_type === 'Med/NonMed'} />
                                            </td>
                                        </tr>
                                    }
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>

                    <div>
    <label className="req">Reason for Transfer</label>
    <select value={reason} onChange={(e) => setReason(e.target.value)}>
        <option value="">Select a reason</option>
        <option value="Borrowed">Borrowed</option>
        <option value="Overstock">Overstock</option>
        <option value="Not used">Not used</option>
        <option value="Relocation">Relocation</option>
        <option value="other">Other</option>
    </select>
    {reason === 'other' && (
        <div>
            <label>Please specify</label>
            <textarea rows={4} value={reason} onChange={(e) => setReason(e.target.value)} />
        </div>
    )}
</div>
                </div>
            </form>
        </Modal>
    )
});
const GuidedCapturePanel = ({ clientId, stationPointId, assetCatId, clients }) => {
    const [expectedAssets, setExpectedAssets] = useState([]);
    const [captureProgress, setCaptureProgress] = useState({});

    useEffect(() => {
        if (clientId && stationPointId) {
            loadExpectedAssets();
        }
    }, [clientId, stationPointId]);

    const loadExpectedAssets = async () => {
        try {
            // Get facility level first
            const facility = clients.find(c => c.id === clientId);
            if (facility && facility.level) {
                const response = await AssetService.getBaseline(facility.level, stationPointId);
                const filtered = response.data.filter(item => 
                    item.asset_cat_id === assetCatId
                );
                setExpectedAssets(filtered);
                
                // Calculate capture progress
                const progress = {};
                filtered.forEach(asset => {
                    progress[asset.item_id] = {
                        expected: asset.expected_quantity,
                        captured: 0, // This would come from actual asset count
                        percentage: 0
                    };
                });
                setCaptureProgress(progress);
            }
        } catch (error) {
            console.error('Failed to load expected assets:', error);
        }
    };

    if (expectedAssets.length === 0) return null;

    return (
        <Card 
            title="Capture Guide" 
            size="small"
            style={{ 
                position: 'fixed', 
                right: '20px', 
                top: '100px', 
                width: '300px',
                zIndex: 1000,
                maxHeight: '60vh',
                overflowY: 'auto'
            }}
        >
            <div style={{ marginBottom: '12px' }}>
                <Progress
                    percent={Math.round(
                        (Object.values(captureProgress).filter(p => p.percentage >= 100).length / 
                         Object.values(captureProgress).length) * 100
                    )}
                    size="small"
                    status="active"
                />
                <div style={{ fontSize: '12px', color: '#666', textAlign: 'center' }}>
                    Overall Progress
                </div>
            </div>

            <div>
                {expectedAssets.map(asset => {
                    const progress = captureProgress[asset.item_id] || { expected: 0, captured: 0, percentage: 0 };
                    const isComplete = progress.percentage >= 100;
                    
                    return (
                        <div 
                            key={asset.item_id} 
                            style={{ 
                                marginBottom: '8px',
                                padding: '8px',
                                backgroundColor: isComplete ? '#f6ffed' : '#fff2f0',
                                borderRadius: '4px',
                                border: `1px solid ${isComplete ? '#b7eb8f' : '#ffccc7'}`
                            }}
                        >
                            <div style={{ 
                                fontSize: '12px', 
                                fontWeight: '500',
                                marginBottom: '4px'
                            }}>
                                {asset.item_name}
                                {asset.is_mandatory && (
                                    <span style={{ color: '#f5222d', marginLeft: '4px' }}>*</span>
                                )}
                            </div>
                            
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                fontSize: '11px',
                                color: '#666'
                            }}>
                                <span>Expected: {progress.expected}</span>
                                <span>Captured: {progress.captured}</span>
                            </div>
                            
                            <Progress
                                percent={progress.percentage}
                                size="small"
                                showInfo={false}
                                strokeColor={isComplete ? '#52c41a' : '#faad14'}
                            />
                        </div>
                    );
                })}
            </div>
        </Card>
    );
};
// Quality Score Display Component
const DataQualityPanel = ({ qualityScore, isVisible }) => {
    if (!isVisible) return null;

    const getIcon = (type) => {
        switch (type) {
            case 'success': return <CheckCircleOutlined style={{ color: '#22c55e' }} />;
            case 'warning': return <ExclamationCircleOutlined style={{ color: '#f59e0b' }} />;
            case 'error': return <CloseCircleOutlined style={{ color: '#ef4444' }} />;
            case 'info': return <InfoCircleOutlined style={{ color: '#3b82f6' }} />;
            default: return null;
        }
    };

    return (
        <div style={{ 
            position: 'fixed', 
            right: '20px', 
            top: '20px', 
            width: '300px', 
            backgroundColor: 'white', 
            border: '1px solid #d9d9d9', 
            borderRadius: '8px', 
            padding: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            zIndex: 1001,
            maxHeight: '70vh',
            overflowY: 'auto'
        }}>
            <div style={{ marginBottom: '16px' }}>
                <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 'bold' }}>
                    Data Quality Score
                </h4>
                
                {/* Score Display */}
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                    <div style={{ 
                        fontSize: '32px', 
                        fontWeight: 'bold', 
                        color: qualityScore.qualityColor,
                        marginBottom: '8px'
                    }}>
                        {qualityScore.percentage}%
                    </div>
                    <div style={{ 
                        fontSize: '12px',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        backgroundColor: qualityScore.qualityColor + '20',
                        color: qualityScore.qualityColor,
                        display: 'inline-block'
                    }}>
                        {qualityScore.qualityLevel}
                    </div>
                    <div style={{ fontSize: '10px', color: '#666', marginTop: '4px' }}>
                        {qualityScore.totalScore} / {qualityScore.maxScore} points
                    </div>
                </div>

                {/* Progress Bar */}
                <div style={{ 
                    width: '100%', 
                    height: '8px', 
                    backgroundColor: '#f0f0f0', 
                    borderRadius: '4px',
                    marginBottom: '16px'
                }}>
                    <div style={{ 
                        height: '8px', 
                        borderRadius: '4px',
                        width: `${qualityScore.percentage}%`,
                        backgroundColor: qualityScore.qualityColor,
                        transition: 'width 0.3s ease'
                    }} />
                </div>

                {/* Critical Issues Alert */}
                {qualityScore.criticalIssues > 0 && (
                    <div style={{ 
                        backgroundColor: '#fef2f2', 
                        border: '1px solid #fecaca', 
                        borderRadius: '6px', 
                        padding: '8px',
                        marginBottom: '12px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <CloseCircleOutlined style={{ color: '#ef4444', marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', fontWeight: '500', color: '#991b1b' }}>
                                {qualityScore.criticalIssues} critical issue(s) remaining
                            </span>
                        </div>
                    </div>
                )}

                {/* Quality Rules */}
                <div>
                    <h5 style={{ fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '8px' }}>
                        Quality Checklist
                    </h5>
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {qualityScore.rules.map((rule, index) => (
                            <div key={index} style={{ 
                                display: 'flex', 
                                alignItems: 'flex-start', 
                                marginBottom: '8px',
                                fontSize: '11px'
                            }}>
                                <div style={{ marginRight: '8px', marginTop: '2px' }}>
                                    {getIcon(rule.type)}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ 
                                        color: rule.type === 'success' ? '#166534' :
                                               rule.type === 'warning' ? '#92400e' :
                                               rule.type === 'error' ? '#991b1b' : '#1e40af',
                                        lineHeight: '1.3'
                                    }}>
                                        {rule.message}
                                    </div>
                                    <div style={{ color: '#666', fontSize: '10px' }}>
                                        {rule.weight} points {rule.critical ? '(required)' : '(optional)'}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Quality Tips */}
                <div style={{ 
                    marginTop: '12px',
                    padding: '8px', 
                    backgroundColor: '#eff6ff', 
                    border: '1px solid #bfdbfe', 
                    borderRadius: '6px'
                }}>
                    <h6 style={{ fontSize: '11px', fontWeight: '500', color: '#1e40af', marginBottom: '4px' }}>
                        Tips for Better Quality
                    </h6>
                    <ul style={{ margin: 0, paddingLeft: '12px', fontSize: '10px', color: '#1e40af' }}>
                        <li>Fill all required fields completely</li>
                        <li>Add photos for better documentation</li>
                        <li>Include detailed remarks</li>
                        <li>Specify data source for reliability</li>
                        <li>Use proper formats (registration plates, etc.)</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
// IMPROVED BaselineManagement Component
const BaselineManagement = ({ clients, stationPoints, items, isVisible }) => {
    const [complianceData, setComplianceData] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dashboardStats, setDashboardStats] = useState(null);

    const facilityLevels = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5'];

    // Efficient compliance calculation with caching
    const calculateCompliance = useCallback(async (facilityId) => {
    if (!facilityId) return [];
    
    try {
        setLoading(true);
        
        const [complianceResponse, statsResponse] = await Promise.all([
            AssetService.getComplianceStatus(facilityId),  // This returns the gaps data
            AssetService.getComplianceAnalytics()          // This returns the dashboard stats
        ]);
        
        console.log('Compliance API response:', complianceResponse);
        console.log('Stats API response:', statsResponse);
        
        // Fix: Extract the data correctly
        const compliance = complianceResponse.data?.data || complianceResponse.data || [];
        const stats = statsResponse.data?.data || statsResponse.data || {};
        
        setComplianceData(compliance);
        setDashboardStats(stats);
        
        return compliance;
    } catch (error) {
        console.error('Error calculating compliance:', error);
        message.error('Failed to load compliance data');
        setComplianceData([]);
        setDashboardStats(null);
        return [];
    } finally {
        setLoading(false);
    }
}, []);
    // Debounced facility selection
    const debouncedFacilityChange = useMemo(
        () => debounce((facilityId) => {
            if (facilityId) {
                calculateCompliance(facilityId);
            } else {
                setComplianceData([]);
                setDashboardStats(null);
            }
        }, 300),
        [calculateCompliance]
    );

    useEffect(() => {
        debouncedFacilityChange(selectedFacility);
        return () => debouncedFacilityChange.cancel();
    }, [selectedFacility, debouncedFacilityChange]);

    if (!isVisible) return null;

    return (
        <div>
            {/* Baseline Setup */}
            <ImprovedBaselineSetup
                facilityLevels={facilityLevels}
                stationPoints={stationPoints}
                items={items}
            />
             <FacilityComplianceGraph isVisible={isVisible} />
               {/* ── Asset Gaps — separated by category ─────────────────── */}
               <AssetsWithoutBaselinesTabs isVisible={isVisible} />
               {/* ────────────────────────────────────────────────────────── */}
            {/* Compliance Management */}
            <div style={{ marginTop: '24px' }}>
                <Card title="Asset Baseline Compliance Dashboard">
                    <Row gutter={[16, 16]}>
                        <Col span={7}>
                            <Card size="small" title="Select Facility">
                                <AntdSelect
                                    placeholder="Choose Facility"
                                    showSearch
                                    loading={loading}
                                    options={clients.map(c => ({ 
                                        value: c.id, 
                                        label: `${c.name} (${c.site_type || 'Unknown'})` 
                                    }))}
                                    value={selectedFacility}
                                    onChange={setSelectedFacility}
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Card>
                        </Col>

                        <Col span={18}>
                            {selectedFacility && (
                                <ImprovedComplianceOverview 
                                    facilityId={selectedFacility}
                                    complianceData={complianceData}
                                    dashboardStats={dashboardStats}
                                    loading={loading}
                                />
                            )}
                        </Col>
                    </Row>

                    {selectedFacility && (
                        <div style={{ marginTop: '16px' }}>
                            <ImprovedAssetGapsTable 
                                facilityId={selectedFacility}
                                stationPoints={stationPoints}
                                complianceData={complianceData}
                                loading={loading}
                            />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};

// IMPROVED BaselineSetup Component
const ImprovedBaselineSetup = ({ facilityLevels, stationPoints, items }) => {
    const [baselineData, setBaselineData] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState('Level 1');
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [existingCount, setExistingCount] = useState(0);

    // Memoized filtered items for better performance
    const filteredItems = useMemo(() => {
        return items.map(item => ({
            value: item.id,
            label: item.item_full_name || item.name || `Item ${item.id}`,
            searchText: `${item.item_full_name || item.name || ''} ${item.description || ''}`.toLowerCase()
        }));
    }, [items]);
const clearCacheAndReload = async () => {
    try {
        // Clear cache for current level
        if (AssetService.clearCache) {
            AssetService.clearCache(`baselines_level_${selectedLevel}`);
        }
        
        // Or if you have a clearAllCache method
        if (AssetService.clearAllCache) {
            AssetService.clearAllCache();
        }
        
        // Force reload
        await loadExistingBaselines();
    } catch (error) {
        console.error('Error clearing cache:', error);
    }
};
   const loadExistingBaselines = async () => {
    console.log('loadExistingBaselines called with selectedLevel:', selectedLevel);

    if (!selectedLevel) return;
    
    try {
        setIsLoading(true);
        console.log('About to call AssetService.getBaselinesByLevel with:', selectedLevel);
        
        const response = await AssetService.getBaselinesByLevel(selectedLevel);
        console.log('Response received:', response);
        
        // Fix: Access the nested data array
        const baselineData = response.data?.data || response.data || [];
        
        if (baselineData.length > 0) {
            const existingData = baselineData.map(item => ({
                id: `existing_${item.id}`,
                baseline_id: item.id,
                facility_level: selectedLevel,
                station_point_id: item.station_point_id,
                item_id: item.item_id,
                expected_quantity: item.expected_quantity,
                is_mandatory: item.is_mandatory === 1,
                notes: item.notes || ''
            }));
            
            setBaselineData(existingData);
            setExistingCount(existingData.length);
            message.success(`Loaded ${existingData.length} existing baseline items for ${selectedLevel}`);
        } else {
            setBaselineData([]);
            setExistingCount(0);
            message.info(`No existing baselines found for ${selectedLevel}`);
        }
    } catch (error) {
        console.error('Failed to load baselines:', error);
        message.error('Failed to load existing baselines');
        setBaselineData([]);
        setExistingCount(0);
    } finally {
        setIsLoading(false);
    }
};

    const addBaselineItem = () => {
          const lastRowStationPoint = baselineData.length > 0 ? 
        baselineData[baselineData.length - 1].station_point_id : null;
        const newItem = {
            id: `new_${Date.now()}`,
            facility_level: selectedLevel,
            station_point_id: lastRowStationPoint,
            item_id: null,
            expected_quantity: 1,
            is_mandatory: true,
            notes: ''
        };
        setBaselineData([...baselineData, newItem]);
    };

    const updateBaselineItem = useCallback((index, field, value) => {
        setBaselineData(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    }, []);

    const removeBaselineItem = useCallback((index) => {
        setBaselineData(prev => prev.filter((_, i) => i !== index));
    }, []);

    // Optimized save function
    const saveBaseline = async () => {
        if (baselineData.length === 0) {
            message.error('Please add at least one baseline item before saving');
            return;
        }

        // Validate data
        const invalidItems = baselineData.filter(item => 
            !item.station_point_id || !item.item_id || !item.expected_quantity || item.expected_quantity < 1
        );

        if (invalidItems.length > 0) {
            message.error(`${invalidItems.length} items have missing or invalid data. Please complete all required fields.`);
            return;
        }

        setIsSaving(true);
        try {
            const preparedData = {
                baselines: baselineData.map(item => ({
                    ...(item.baseline_id && { id: item.baseline_id }),
                    facility_level: selectedLevel,
                    station_point_id: parseInt(item.station_point_id),
                    item_id: parseInt(item.item_id),
                    expected_quantity: parseInt(item.expected_quantity),
                    is_mandatory: item.is_mandatory ? 1 : 0,
                    notes: item.notes || ''
                }))
            };

            await AssetService.saveBulkBaseline(preparedData);
            message.success(`Successfully saved ${preparedData.baselines.length} baseline items`);
            
            // Reload to show updated data
            await loadExistingBaselines();
            
        } catch (error) {
            console.error('Failed to save baseline:', error);
            message.error('Failed to save baseline: ' + (error.response?.data?.message || error.message));
        } finally {
            setIsSaving(false);
        }
    };
// Add this useEffect in the ImprovedBaselineSetup component
useEffect(() => {
    const loadExistingCount = async () => {
        if (!selectedLevel) {
            setExistingCount(0);
            return;
        }
        
        try {
            const response = await AssetService.getBaselinesByLevel(selectedLevel);
            const count = response.data?.data?.length || 0;
            setExistingCount(count);
        } catch (error) {
            console.error('Error loading baseline count:', error);
            setExistingCount(0);
        }
    };

    loadExistingCount();
}, [selectedLevel]); // Auto-run when selectedLevel changes
    // Optimized table columns
    const tableColumns = useMemo(() => [
        {
            title: 'Station Point',
            dataIndex: 'station_point_id',
            width: 200,
            render: (value, record, index) => (
                <AntdSelect
                    showSearch
                    placeholder="Select station point"
                    options={stationPoints.map(sp => ({ value: sp.id, label: sp.name }))}
                    value={value}
                    onChange={v => updateBaselineItem(index, 'station_point_id', v)}
                    style={{ width: '100%' }}
                    filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                    }
                />
            )
        },
        {
            title: 'Asset',
            dataIndex: 'item_id',
            width: 300,
            render: (value, record, index) => (
                <AntdSelect
                    showSearch
                    placeholder="Select asset"
                    options={filteredItems}
                    value={value}
                    onChange={v => updateBaselineItem(index, 'item_id', v)}
                    style={{ width: '100%' }}
                    filterOption={(input, option) =>
                        option.searchText.includes(input.toLowerCase())
                    }
                />
            )
        },
        {
            title: 'Expected Qty',
            dataIndex: 'expected_quantity',
            width: 120,
            render: (value, record, index) => (
                <Input
                    type="number"
                    min="1"
                    max="9999"
                    value={value}
                    onChange={e => {
                        const qty = parseInt(e.target.value) || 1;
                        updateBaselineItem(index, 'expected_quantity', Math.max(1, qty));
                    }}
                    style={{ 
                        borderColor: !value || value <= 0 ? '#ff4d4f' : undefined,
                        width: '80px'
                    }}
                />
            )
        },
        {
            title: 'Mandatory',
            dataIndex: 'is_mandatory',
            width: 100,
            render: (value, record, index) => (
                <AntSelect
                    value={value}
                    onChange={v => updateBaselineItem(index, 'is_mandatory', v)}
                    style={{ width: '80px' }}
                    options={[
                        { value: true, label: 'Yes' },
                        { value: false, label: 'No' }
                    ]}
                />
            )
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            width: 200,
            render: (value, record, index) => (
                <Input
                    value={value}
                    onChange={e => updateBaselineItem(index, 'notes', e.target.value)}
                    placeholder="Optional notes"
                    maxLength={255}
                />
            )
        },
        {
            title: 'Action',
            width: 80,
            render: (_, record, index) => (
                <Popconfirm
                    title="Remove this baseline item?"
                    onConfirm={() => removeBaselineItem(index)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button 
                        danger 
                        size="small"
                        icon={<DeleteOutlined />}
                        type="text"
                    />
                </Popconfirm>
            )
        }
    ], [stationPoints, filteredItems, updateBaselineItem, removeBaselineItem]);

    return (
        <Card title="Setup Asset Baselines" loading={isLoading}>
            <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
                <Col span={6}>
                    <label>Facility Level</label>
                    <AntdSelect
                        options={facilityLevels.map(level => ({ value: level, label: level }))}
                        value={selectedLevel}
                        onChange={(value) => {
                            setSelectedLevel(value);
                            setBaselineData([]);
                            setExistingCount(0);
                        }}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col span={6}>
                    <Button 
                        type="primary" 
                        onClick={addBaselineItem}
                        disabled={isSaving}
                        icon={<PlusOutlined />}
                    >
                        Add Baseline Item
                    </Button>
                </Col>
                <Col span={6}>
                   <Button 
    onClick={loadExistingBaselines}
    loading={isLoading}
    disabled={!selectedLevel}
>
    {isLoading ? 'Loading...' : `Load Existing ${existingCount > 0 ? `(${existingCount})` : ''}`}
</Button>
                </Col>
                <Col span={6}>
                    <Button 
                        type="primary" 
                        onClick={saveBaseline}
                        loading={isSaving}
                        disabled={baselineData.length === 0}
                        icon={<CheckCircleOutlined />}
                    >
                        Save All Changes
                    </Button>
                    <Button 
    onClick={clearCacheAndReload}
    type="danger"
    size="small"
>
    Clear Cache & Reload
</Button>
                </Col>
            </Row>

            {baselineData.length > 0 && (
                <Table
                    size="small"
                    dataSource={baselineData}
                    columns={tableColumns}
                    rowKey="id"
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
                    }}
                    scroll={{ x: 1000 }}
                    loading={isSaving}
                />
            )}
        </Card>
    );
};
// AssetsWithoutBaselines.js
const { RangePicker } = DatePicker;

// ── Tabbed wrapper — one tab per asset category ─────────────────────────────
const AssetsWithoutBaselinesTabs = ({ isVisible }) => {
    const [activeCategory, setActiveCategory] = useState('2');

    const categoryTabs = [
        { key: '2', label: '🖥️ Non Medical' },
        { key: '3', label: '🏥 Medical'     },
        { key: '8', label: '🚗 Vehicles'    },
        { key: '9', label: '📦 Supplies'    },
    ];

    if (!isVisible) return null;

    return (
        <div style={{ marginTop: 24 }}>
            <div style={{
                fontWeight: 700,
                fontSize: 15,
                marginBottom: 8,
                paddingLeft: 4,
                borderLeft: '4px solid #1677ff',
                paddingLeft: 10,
                color: '#333'
            }}>
                Assets Without Baselines — by Category
            </div>
            <Tabs
                activeKey={activeCategory}
                onChange={setActiveCategory}
                type="card"
                size="small"
                items={categoryTabs.map(cat => ({
                    key: cat.key,
                    label: cat.label,
                    children: (
                        <AssetsWithoutBaselines
                            key={cat.key}
                            isVisible={activeCategory === cat.key}
                            asset_cat_id={cat.key}
                        />
                    )
                }))}
            />
        </div>
    );
};
// ─────────────────────────────────────────────────────────────────────────────

const AssetsWithoutBaselines = ({ isVisible, asset_cat_id }) => {
    const [loading, setLoading] = useState(false);
    const [assetsData, setAssetsData] = useState([]);
    const [filteredAssets, setFilteredAssets] = useState([]);
    const [analytics, setAnalytics] = useState(null);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [dateRange, setDateRange] = useState(null);
    const [clients, setClients] = useState([]);

    // Get unique facility levels from clients
    const facilityLevels = [...new Set(clients.map(c => c.level).filter(Boolean))].sort();

    useEffect(() => {
        if (isVisible) {
            loadClients();
            loadAssetsWithoutBaselines();
        }
    }, [isVisible, asset_cat_id]);

    useEffect(() => {
        if (selectedFacility) {
            loadAssetsWithoutBaselines(selectedFacility);
        } else {
            loadAssetsWithoutBaselines();
        }
    }, [selectedFacility]);

    // Filter assets based on level and date range
    useEffect(() => {
        let filtered = [...assetsData];

        // Filter by facility level
        if (selectedLevel) {
            filtered = filtered.filter(asset => asset.facility_level === selectedLevel);
        }

        // Filter by date range
        if (dateRange && dateRange.length === 2) {
            const [startDate, endDate] = dateRange;
            filtered = filtered.filter(asset => {
                const assetDate = moment(asset.created);
                return assetDate.isBetween(startDate, endDate, 'day', '[]');
            });
        }

        setFilteredAssets(filtered);
    }, [assetsData, selectedLevel, dateRange]);

    const loadClients = async () => {
        try {
            const response = await FacilityService.all({ status: 1 });
            const clientsData = response.data.result.data.map(v => ({
                id: v.id,
                name: v.business_name,
                level: v.site_type || 'Unknown'
            }));
            setClients(clientsData);
        } catch (error) {
            console.error('Error loading clients:', error);
        }
    };

    const loadAssetsWithoutBaselines = async (facilityId = null) => {
        setLoading(true);
        try {
            const [assetsResponse, analyticsResponse] = await Promise.all([
                AssetService.getAssetsWithoutBaselines(facilityId, asset_cat_id),
                AssetService.getAssetsWithoutBaselinesAnalytics(facilityId, asset_cat_id)
            ]);

            setAssetsData(assetsResponse.data?.data || []);
            setAnalytics(analyticsResponse.data?.data || {});
        } catch (error) {
            console.error('Error loading assets without baselines:', error);
            message.error('Failed to load assets data');
        } finally {
            setLoading(false);
        }
    };

    const clearFilters = () => {
        setSelectedFacility(null);
        setSelectedLevel(null);
        setDateRange(null);
    };

    const createBaseline = (asset) => {
        Modal.confirm({
            title: 'Create Baseline for Asset',
            content: (
                <div>
                    <p>Create a baseline for:</p>
                    <p><strong>Asset:</strong> {asset.item_name}</p>
                    <p><strong>Facility:</strong> {asset.facility_name} ({asset.facility_level})</p>
                    <p><strong>Location:</strong> {asset.station_point_name}</p>
                    <p><strong>Current Quantity:</strong> {asset.quantity}</p>
                </div>
            ),
            onOk: async () => {
                try {
                    const baselineData = {
                        facility_level: asset.facility_level,
                        station_point_id: asset.station_point_id,
                        item_id: asset.item_id,
                        expected_quantity: asset.quantity,
                        is_mandatory: 0,
                        notes: `Auto-created from existing asset ${asset.serial_no}`
                    };

                    await AssetService.createBaseline(baselineData);
                    message.success('Baseline created successfully');
                    loadAssetsWithoutBaselines(selectedFacility);
                } catch (error) {
                    message.error('Failed to create baseline: ' + error.message);
                }
            }
        });
    };

    const viewAssetDetails = (asset) => {
        Modal.info({
            title: 'Asset Details',
            width: 600,
            content: (
                <div>
                    <Row gutter={[16, 8]}>
                        <Col span={8}><strong>Asset Name:</strong></Col>
                        <Col span={16}>{asset.item_name}</Col>
                        
                        <Col span={8}><strong>Category:</strong></Col>
                        <Col span={16}>{asset.category_name} - {asset.subcategory_name}</Col>
                        
                        <Col span={8}><strong>Facility:</strong></Col>
                        <Col span={16}>{asset.facility_name} ({asset.facility_level})</Col>
                        
                        <Col span={8}><strong>Location:</strong></Col>
                        <Col span={16}>{asset.station_point_name || 'Unknown'}</Col>
                        
                        <Col span={8}><strong>Identifier:</strong></Col>
                        <Col span={16}>{asset.serial_no || 'Not specified'}</Col>
                        
                        <Col span={8}><strong>Quantity:</strong></Col>
                        <Col span={16}>{asset.quantity}</Col>
                        
                        <Col span={8}><strong>Status:</strong></Col>
                        <Col span={16}>{asset.status_name}</Col>
                        
                        <Col span={8}><strong>Added:</strong></Col>
                        <Col span={16}>{moment(asset.created).format('DD MMM YYYY HH:mm')}</Col>
                    </Row>
                </div>
            )
        });
    };

    // Calculate filtered analytics
    const getFilteredAnalytics = () => {
        if (!filteredAssets.length) {
            return {
                total_assets: 0,
                facilities_affected: 0,
                categories_affected: 0,
                levels_affected: 0
            };
        }

        return {
            total_assets: filteredAssets.length,
            facilities_affected: new Set(filteredAssets.map(a => a.facility_id)).size,
            categories_affected: new Set(filteredAssets.map(a => a.category_name).filter(Boolean)).size,
            levels_affected: new Set(filteredAssets.map(a => a.facility_level)).size
        };
    };

    const filteredAnalytics = getFilteredAnalytics();

    const columns = [
        {
            title: 'Facility',
            dataIndex: 'facility_name',
            key: 'facility_name',
            width: 200,
            sorter: (a, b) => a.facility_name.localeCompare(b.facility_name),
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 'bold' }}>{text}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{record.facility_level}</div>
                </div>
            )
        },
        {
            title: 'Asset Name',
            dataIndex: 'item_name',
            key: 'item_name',
            width: 250,
            sorter: (a, b) => a.item_name.localeCompare(b.item_name),
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 'bold' }}>{text}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        {record.category_name} - {record.subcategory_name}
                    </div>
                </div>
            )
        },
        {
            title: 'Identifier',
            dataIndex: 'serial_no',
            key: 'serial_no',
            width: 150
        },
        {
            title: 'Location',
            dataIndex: 'station_point_name',
            key: 'station_point_name',
            width: 150,
            render: (text) => text || 'Unknown Location'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            width: 100,
            align: 'center'
        },
        {
            title: 'Status',
            dataIndex: 'status_name',
            key: 'status_name',
            width: 120,
            render: (text) => <Tag color="blue">{text}</Tag>
        },
        {
            title: 'Added Date',
            dataIndex: 'created',
            key: 'created',
            width: 120,
            sorter: (a, b) => new Date(a.created) - new Date(b.created),
            render: (date) => moment(date).format('DD MMM YYYY')
        },
        {
            title: 'Action',
            key: 'action',
            width: 180,
            render: (_, record) => (
                <Space>
                    <Button 
                        size="small" 
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => createBaseline(record)}
                    >
                        Create Baseline
                    </Button>
                    <Button 
                        size="small"
                        onClick={() => viewAssetDetails(record)}
                    >
                        Details
                    </Button>
                </Space>
            )
        }
    ];

    if (!isVisible) return null;

    return (
        <div style={{ marginTop: '24px' }}>
            <Card 
                title="Assets Without Baselines" 
                loading={loading}
                extra={
                    <Space wrap>
                        {/* Facility Filter */}
                        <Select
                            placeholder="All Facilities"
                            style={{ width: 200 }}
                            allowClear
                            showSearch
                            value={selectedFacility}
                            onChange={setSelectedFacility}
                            filterOption={(input, option) => {
                                const label = option.label || '';
                                return label.toLowerCase().includes(input.toLowerCase());
                            }}
                        >
                            {clients.map(client => (
                                <Option 
                                    key={client.id} 
                                    value={client.id}
                                    label={`${client.name} (${client.level})`}
                                >
                                    {client.name} ({client.level})
                                </Option>
                            ))}
                        </Select>

                        {/* Level Filter */}
                        <Select
                            placeholder="All Levels"
                            style={{ width: 130 }}
                            allowClear
                            value={selectedLevel}
                            onChange={setSelectedLevel}
                        >
                            {facilityLevels.map(level => (
                                <Option key={level} value={level}>{level}</Option>
                            ))}
                        </Select>

                        {/* Date Range Filter */}
                        <RangePicker
                            placeholder={['Start Date', 'End Date']}
                            value={dateRange}
                            onChange={setDateRange}
                            style={{ width: 250 }}
                            format="DD MMM YYYY"
                            allowClear
                        />

                        {/* Clear Filters Button */}
                        <Button 
                            icon={<FilterOutlined />}
                            onClick={clearFilters}
                            disabled={!selectedFacility && !selectedLevel && !dateRange}
                        >
                            Clear Filters
                        </Button>
                    </Space>
                }
            >
                {/* Updated Analytics Cards */}
                <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
                    <Col span={6}>
                        <Card size="small">
                            <Statistic
                                title="Total Assets"
                                value={filteredAnalytics.total_assets}
                                valueStyle={{ color: '#1890ff' }}
                            />
                            {assetsData.length !== filteredAnalytics.total_assets && (
                                <div style={{ fontSize: '12px', color: '#666' }}>
                                    of {assetsData.length} total
                                </div>
                            )}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card size="small">
                            <Statistic
                                title="Facilities Affected"
                                value={filteredAnalytics.facilities_affected}
                                valueStyle={{ color: '#fa8c16' }}
                            />
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card size="small">
                            <Statistic
                                title="Categories Affected"
                                value={filteredAnalytics.categories_affected}
                                valueStyle={{ color: '#722ed1' }}
                            />
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card size="small">
                            <Statistic
                                title="Levels Affected"
                                value={filteredAnalytics.levels_affected}
                                valueStyle={{ color: '#52c41a' }}
                            />
                        </Card>
                    </Col>
                </Row>

                {/* Active Filters Display */}
                {(selectedFacility || selectedLevel || dateRange) && (
                    <div style={{ marginBottom: '16px', padding: '8px', backgroundColor: '#f0f2f5', borderRadius: '4px' }}>
                        <Space wrap>
                            <span style={{ fontWeight: 'bold' }}>Active Filters:</span>
                            {selectedFacility && (
                                <Tag closable onClose={() => setSelectedFacility(null)}>
                                    Facility: {clients.find(c => c.id === selectedFacility)?.name}
                                </Tag>
                            )}
                            {selectedLevel && (
                                <Tag closable onClose={() => setSelectedLevel(null)}>
                                    Level: {selectedLevel}
                                </Tag>
                            )}
                            {dateRange && (
                                <Tag closable onClose={() => setDateRange(null)}>
                                    Date: {dateRange[0].format('DD MMM YYYY')} - {dateRange[1].format('DD MMM YYYY')}
                                </Tag>
                            )}
                        </Space>
                    </div>
                )}

                <Table
                    columns={columns}
                    dataSource={filteredAssets}
                    rowKey="asset_id"
                    loading={loading}
                    size="small"
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => 
                            `${range[0]}-${range[1]} of ${total} assets`
                    }}
                    scroll={{ x: 1200 }}
                />
            </Card>
        </div>
    );
};
// IMPROVED ComplianceOverview Component
  const ImprovedComplianceOverview = ({ facilityId, complianceData, dashboardStats, loading }) => {
    const stats = useMemo(() => {
        if (!Array.isArray(complianceData) || complianceData.length === 0) {
            return {
                overallCompliance: 0,
                missingCount: 0,
                excessCount: 0,
                compliantCount: 0,
                criticalMissing: dashboardStats?.critical_missing_count || 0 // Use from API
            };
        }
        
        const totalCompliance = complianceData.reduce((sum, item) => sum + (item.compliance_percentage || 0), 0);
        const overallCompliance = Math.round(totalCompliance / complianceData.length);
        
        return {
            overallCompliance,
            missingCount: complianceData.filter(item => item.status === 'missing').length,
            excessCount: complianceData.filter(item => item.status === 'excess').length,
            compliantCount: complianceData.filter(item => item.status === 'complete').length,
            criticalMissing: dashboardStats?.critical_missing_count || 
                complianceData.filter(item => item.status === 'missing' && item.is_mandatory === 1).length
        };
    }, [complianceData, dashboardStats]); // Add dashboardStats to dependencies

    // Rest of component...
    // Rest of component...
    const getComplianceColor = (percentage) => {
        if (percentage >= 90) return '#52c41a';
        if (percentage >= 70) return '#faad14'; 
        if (percentage >= 50) return '#fa8c16';
        return '#f5222d';
    };

    return (
        <Card size="small" title="Compliance Dashboard" loading={loading}>
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <Statistic
                        title="Selected Facility Compliance"
                        value={stats.overallCompliance}
                        suffix="%"
                        valueStyle={{ color: getComplianceColor(stats.overallCompliance) }}
                    />
                    <Progress 
                        percent={stats.overallCompliance} 
                        strokeColor={getComplianceColor(stats.overallCompliance)}
                        size="small"
                        showInfo={false}
                    />
                </Col>

                <Col span={4}>
                    <Statistic
                        title="Selected Facility Assets Gap"
                        value={stats.missingCount}
                        valueStyle={{ color: '#f5222d' }}
                    />
                </Col>
                <Col span={4}>
                    <Statistic
                        title="Excess Assets"
                        value={stats.excessCount}
                        valueStyle={{ color: '#fa8c16' }}
                    />
                </Col>
                <Col span={6}>
                    <Statistic
                        title="Compliant"
                        value={stats.compliantCount}
                        valueStyle={{ color: '#52c41a' }}
                    />
                </Col>
            </Row>
        </Card>
    );
};
const { Option } = Select;


const FacilityComplianceGraph = ({ isVisible }) => {
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [chartType, setChartType] = useState('bar');
    const [displayCount, setDisplayCount] = useState(20);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedLevel, setSelectedLevel] = useState('all'); // Add level filter state
    const chartRef = useRef();

    useEffect(() => {
        if (isVisible) {
            loadFacilityCompliance();
        }
    }, [isVisible]);

    // Filter data when level selection changes
    useEffect(() => {
        if (selectedLevel === 'all') {
            setFilteredData(chartData);
        } else {
            setFilteredData(chartData.filter(facility => facility.level === selectedLevel));
        }
        setCurrentPage(0); // Reset to first page when filter changes
    }, [chartData, selectedLevel]);

    const loadFacilityCompliance = async () => {
        setLoading(true);
        try {
            const response = await AssetService.getFacilityComplianceData();
            const data = response.data?.data || [];
            
            const chartData = data
                .map(facility => ({
                    name: facility.facility_name.length > 15 
                        ? facility.facility_name.substring(0, 15) + '...' 
                        : facility.facility_name,
                    fullName: facility.facility_name,
                    level: facility.facility_level,
                    compliance: parseFloat(facility.avg_compliance || 0),
                    missing: parseInt(facility.missing_items || 0),
                    compliant: parseInt(facility.compliant_items || 0),
                    total: parseInt(facility.total_items || 0),
                    critical: parseInt(facility.critical_missing || 0)
                }))
                .filter(facility => facility.total > 0)
                .sort((a, b) => b.compliance - a.compliance);

            setChartData(chartData);
        } catch (error) {
            console.error('Error loading facility compliance:', error);
            message.error('Failed to load facility compliance data');
        } finally {
            setLoading(false);
        }
    };

    // Get unique levels for filter dropdown
    const availableLevels = useMemo(() => {
        const levels = [...new Set(chartData.map(item => item.level))].filter(Boolean);
        return levels.sort();
    }, [chartData]);

    // Pagination for filtered data
    const totalPages = Math.ceil(filteredData.length / displayCount);
    const currentData = filteredData.slice(
        currentPage * displayCount, 
        (currentPage + 1) * displayCount
    );

    const chartTypes = [
        { value: 'bar', label: 'Bar Chart', icon: <BarChartOutlined /> },
        { value: 'line', label: 'Line Chart' },
        { value: 'area', label: 'Area Chart' }
    ];

    const getComplianceColor = (compliance) => {
        if (compliance >= 90) return '#52c41a';
        if (compliance >= 70) return '#faad14';
        if (compliance >= 50) return '#fa8c16';
        return '#f5222d';
    };

    // Export functions (updated to use filtered data)
    const exportToPNG = async () => {
        if (chartRef.current) {
            try {
                const canvas = await html2canvas(chartRef.current);
                const link = document.createElement('a');
                link.download = `facility-compliance-${selectedLevel}-page-${currentPage + 1}.png`;
                link.href = canvas.toDataURL();
                link.click();
            } catch (error) {
                message.error('Failed to export PNG');
            }
        }
    };

    const exportToPDF = async () => {
        if (chartRef.current) {
            try {
                const canvas = await html2canvas(chartRef.current);
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('landscape');
                const imgWidth = 280;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                
                pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
                pdf.save(`facility-compliance-${selectedLevel}-page-${currentPage + 1}.pdf`);
            } catch (error) {
                message.error('Failed to export PDF');
            }
        }
    };

    const exportToExcel = () => {
        try {
            const exportData = filteredData.map(item => ({
                'Facility Name': item.fullName,
                'Level': item.level,
                'Compliance %': item.compliance,
                'Total Assets': item.total,
                'Compliant Assets': item.compliant,
                'Missing Assets': item.missing,
                'Critical Missing': item.critical
            }));
            
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Facility Compliance');
            XLSX.writeFile(workbook, `facility-compliance-${selectedLevel}.xlsx`);
        } catch (error) {
            message.error('Failed to export Excel');
        }
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div style={{
                    backgroundColor: 'white',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    padding: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <p style={{ fontWeight: 'bold', margin: '0 0 8px 0' }}>{data.fullName}</p>
                    <p style={{ margin: '4px 0', color: '#666' }}>Level: {data.level}</p>
                    <p style={{ margin: '4px 0', color: getComplianceColor(data.compliance) }}>
                        Compliance: {data.compliance.toFixed(1)}%
                    </p>
                    <p style={{ margin: '4px 0' }}>Total Assets: {data.total}</p>
                    <p style={{ margin: '4px 0', color: '#52c41a' }}>Compliant: {data.compliant}</p>
                    <p style={{ margin: '4px 0', color: '#f5222d' }}>Missing: {data.missing}</p>
                    <p style={{ margin: '4px 0', color: '#ff4d4f' }}>Critical Missing: {data.critical}</p>
                </div>
            );
        }
        return null;
    };

    const renderChart = () => {
        const commonProps = {
            data: currentData,
            margin: { top: 20, right: 30, left: 20, bottom: 100 }
        };

        switch (chartType) {
            case 'bar':
                return (
                    <BarChart {...commonProps}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="name" 
                            angle={-45}
                            textAnchor="end"
                            height={120}
                            interval={0}
                            tick={{ fontSize: 11 }}
                        />
                        <YAxis 
                            label={{ value: 'Compliance %', angle: -90, position: 'insideLeft' }} 
                            domain={[0, 100]}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                        <Bar dataKey="compliance" name="Compliance %" radius={[4, 4, 0, 0]}>
                            {currentData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={getComplianceColor(entry.compliance)} />
                            ))}
                        </Bar>
                    </BarChart>
                );

            case 'line':
                return (
                    <LineChart {...commonProps}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="name" 
                            angle={-45}
                            textAnchor="end"
                            height={120}
                            interval={0}
                            tick={{ fontSize: 11 }}
                        />
                        <YAxis 
                            label={{ value: 'Compliance %', angle: -90, position: 'insideLeft' }} 
                            domain={[0, 100]}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                        <Line 
                            type="monotone" 
                            dataKey="compliance" 
                            stroke="#1890ff" 
                            strokeWidth={2}
                            dot={{ fill: '#1890ff', strokeWidth: 2, r: 4 }}
                        />
                    </LineChart>
                );

            case 'area':
                return (
                    <AreaChart {...commonProps}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="name" 
                            angle={-45}
                            textAnchor="end"
                            height={120}
                            interval={0}
                            tick={{ fontSize: 11 }}
                        />
                        <YAxis 
                            label={{ value: 'Compliance %', angle: -90, position: 'insideLeft' }} 
                            domain={[0, 100]}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                        <Area 
                            type="monotone" 
                            dataKey="compliance" 
                            stroke="#1890ff" 
                            fill="#1890ff" 
                            fillOpacity={0.3}
                        />
                    </AreaChart>
                );

            default:
                return null;
        }
    };

    if (!isVisible) return null;

    return (
        <Card 
            title={`Facility Compliance Overview ${selectedLevel !== 'all' ? `- ${selectedLevel}` : ''}`}
            loading={loading}
            style={{ marginTop: '24px' }}
            extra={
                <Space>
                    {/* Level Filter */}
                    <Select
                        value={selectedLevel}
                        onChange={setSelectedLevel}
                        style={{ width: 120 }}
                        placeholder="Filter by Level"
                    >
                        <Option value="all">All Levels</Option>
                        {availableLevels.map(level => (
                            <Option key={level} value={level}>{level}</Option>
                        ))}
                    </Select>
                    
                    <Select 
                        value={chartType} 
                        onChange={setChartType}
                        style={{ width: 120 }}
                    >
                        {chartTypes.map(type => (
                            <Option key={type.value} value={type.value}>
                                {type.icon} {type.label}
                            </Option>
                        ))}
                    </Select>
                    
                    <Select
                        value={displayCount}
                        onChange={setDisplayCount}
                        style={{ width: 100 }}
                    >
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={30}>30</Option>
                        <Option value={50}>50</Option>
                    </Select>
                    
                    <Button 
                        icon={<DownloadOutlined />} 
                        onClick={exportToPNG}
                        disabled={filteredData.length === 0}
                        size="small"
                    >
                        PNG
                    </Button>
                    
                    <Button 
                        icon={<DownloadOutlined />} 
                        onClick={exportToPDF}
                        disabled={filteredData.length === 0}
                        size="small"
                    >
                        PDF
                    </Button>
                    
                    <Button 
                        icon={<DownloadOutlined />} 
                        onClick={exportToExcel}
                        disabled={filteredData.length === 0}
                        size="small"
                    >
                        Excel
                    </Button>
                </Space>
            }
        >
            {chartData.length > 0 ? (
                <>
                    {/* Chart Summary - Updated to show filtered data stats */}
                    <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                        <Row gutter={16}>
                            <Col span={6}>
                                <Statistic 
                                    title={selectedLevel === 'all' ? 'Total Facilities' : `${selectedLevel} Facilities`}
                                    value={filteredData.length} 
                                    valueStyle={{ fontSize: '18px' }}
                                />
                            </Col>
                            <Col span={6}>
                                <Statistic 
                                    title="Avg Compliance" 
                                    value={filteredData.length > 0 ? filteredData.reduce((sum, item) => sum + item.compliance, 0) / filteredData.length : 0} 
                                    precision={1}
                                    suffix="%"
                                    valueStyle={{ fontSize: '18px' }}
                                />
                            </Col>
                            <Col span={6}>
                                <Statistic 
                                    title="High Performers (≥90%)" 
                                    value={filteredData.filter(item => item.compliance >= 90).length} 
                                    valueStyle={{ fontSize: '18px', color: '#52c41a' }}
                                />
                            </Col>
                            <Col span={6}>
                                <Statistic 
                                    title="Need Attention (<70%)" 
                                    value={filteredData.filter(item => item.compliance < 70).length} 
                                    valueStyle={{ fontSize: '18px', color: '#f5222d' }}
                                />
                            </Col>
                        </Row>
                    </div>

                    {/* Chart with pagination */}
                    <div ref={chartRef}>
                        <ResponsiveContainer width="100%" height={500}>
                            {renderChart()}
                        </ResponsiveContainer>
                    </div>

                    {/* Pagination Controls - Updated to show filtered data info */}
                    {totalPages > 1 && (
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            marginTop: '16px',
                            gap: '12px'
                        }}>
                            <Button 
                                onClick={() => setCurrentPage(0)}
                                disabled={currentPage === 0}
                                size="small"
                            >
                                First
                            </Button>
                            <Button 
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 0}
                                size="small"
                            >
                                Previous
                            </Button>
                            <span style={{ padding: '0 16px' }}>
                                Page {currentPage + 1} of {totalPages} 
                                (Showing {currentData.length} of {filteredData.length} facilities)
                            </span>
                            <Button 
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage >= totalPages - 1}
                                size="small"
                            >
                                Next
                            </Button>
                            <Button 
                                onClick={() => setCurrentPage(totalPages - 1)}
                                disabled={currentPage >= totalPages - 1}
                                size="small"
                            >
                                Last
                            </Button>
                        </div>
                    )}

                    {filteredData.length === 0 && chartData.length > 0 && (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            No facilities found for {selectedLevel}
                        </div>
                    )}
                </>
            ) : (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    No compliance data available
                </div>
            )}
        </Card>
    );
};

// IMPROVED AssetGapsTable Component
const ImprovedAssetGapsTable = ({ facilityId, stationPoints, complianceData, loading }) => {
    const [selectedStationPoint, setSelectedStationPoint] = useState(null);
    const [filteredData, setFilteredData] = useState([]);

    // Filter data when station point changes
    useEffect(() => {
        if (!Array.isArray(complianceData)) {
            setFilteredData([]);
            return;
        }

        let filtered = [...complianceData];
        
        if (selectedStationPoint) {
            filtered = filtered.filter(item => item.station_point_id === selectedStationPoint);
        }

        // Sort by priority
        filtered.sort((a, b) => {
            if (a.is_mandatory !== b.is_mandatory) return b.is_mandatory - a.is_mandatory;
            if (a.status !== b.status) {
                const statusOrder = { 'missing': 0, 'excess': 1, 'complete': 2 };
                return statusOrder[a.status] - statusOrder[b.status];
            }
            return a.item_name.localeCompare(b.item_name);
        });

        setFilteredData(filtered);
    }, [complianceData, selectedStationPoint]);

    const columns = useMemo(() => [
        {
            title: 'Asset Name',
            dataIndex: 'item_name',
            key: 'item_name',
            width: 250,
            sorter: (a, b) => a.item_name.localeCompare(b.item_name),
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: record.is_mandatory ? 'bold' : 'normal' }}>
                        {text}
                        {record.is_mandatory && 
                            <span style={{ color: '#f5222d', marginLeft: 4 }}>*</span>
                        }
                    </div>
                </div>
            )
        },
        {
            title: 'Location',
            dataIndex: 'station_point_name',
            key: 'station_point_name',
            width: 150,
            sorter: (a, b) => a.station_point_name.localeCompare(b.station_point_name)
        },
        {
            title: 'Expected',
            dataIndex: 'expected_quantity',
            key: 'expected_quantity',
            width: 80,
            align: 'center',
            sorter: (a, b) => a.expected_quantity - b.expected_quantity
        },
        {
            title: 'Actual',
            dataIndex: 'actual_quantity', 
            key: 'actual_quantity',
            width: 80,
            align: 'center',
            sorter: (a, b) => a.actual_quantity - b.actual_quantity
        },
        {
            title: 'Gap',
            dataIndex: 'gap',
            key: 'gap',
            width: 80,
            align: 'center',
            sorter: (a, b) => a.gap - b.gap,
            render: (gap, record) => {
                const color = gap < 0 ? 'red' : gap > 0 ? 'orange' : 'green';
                return (
                    <Tag color={color}>
                        {gap > 0 ? '+' : ''}{gap}
                    </Tag>
                );
            }
        },
        {
            title: 'Compliance',
            dataIndex: 'compliance_percentage',
            key: 'compliance_percentage',
            width: 100,
            align: 'center',
            sorter: (a, b) => a.compliance_percentage - b.compliance_percentage,
            render: (percentage) => {
                const color = percentage >= 90 ? '#52c41a' : 
                             percentage >= 70 ? '#faad14' : '#f5222d';
                return (
                    <span style={{ color, fontWeight: 'bold' }}>
                        {percentage.toFixed(1)}%
                    </span>
                );
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            filters: [
                { text: 'Missing', value: 'missing' },
                { text: 'Excess', value: 'excess' },
                { text: 'Complete', value: 'complete' }
            ],
            onFilter: (value, record) => record.status === value,
            render: (status, record) => {
                const statusConfig = {
                    'missing': { 
                        color: 'red', 
                        text: `Missing ${Math.abs(record.gap)}` 
                    },
                    'excess': { 
                        color: 'orange', 
                        text: `Excess ${record.gap}` 
                    },
                    'complete': { 
                        color: 'green', 
                        text: 'Complete' 
                    }
                };
                
                const config = statusConfig[status] || { color: 'default', text: status };
                return <Tag color={config.color}>{config.text}</Tag>;
            }
        }
    ], []);

    return (
        <Card 
            title="Asset Gaps Analysis"
            extra={
                <AntdSelect
                    placeholder="All Locations"
                    showSearch
                    allowClear
                    style={{ width: 200 }}
                    value={selectedStationPoint}
                    onChange={setSelectedStationPoint}
                    options={stationPoints.map(sp => ({ value: sp.id, label: sp.name }))}
                />
            }
        >
            <Table
                columns={columns}
                dataSource={filteredData}
                rowKey={(record) => `${record.item_id}-${record.station_point_id}`}
                loading={loading}
                size="small"
                pagination={{
                    pageSize: 20,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => 
                        `${range[0]}-${range[1]} of ${total} items`
                }}
                scroll={{ x: 800 }}
                rowClassName={(record) => {
                    if (record.status === 'missing') return 'row-missing';
                    if (record.status === 'excess') return 'row-excess';
                    return 'row-complete';
                }}
            />
            
            <style jsx>{`
                .row-missing { background-color: #fff2f0 !important; }
                .row-excess { background-color: #fff7e6 !important; }
                .row-complete { background-color: #f6ffed !important; }
            `}</style>
        </Card>
    );
};

// Add debounce utility if not available
const debounce = (func, wait) => {
    let timeout;
    const debounced = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
    debounced.cancel = () => clearTimeout(timeout);
    return debounced;
};// Update the ComplianceOverview component
// ==================== DATA QUALITY SCORING HOOK ====================
const useDataQualityScore = (formData, assetCatId) => {
    return useMemo(() => {
        const rules = [];
        const formatRules = [];
        const bonusRules = [];
        let totalScore = 0;
        let maxScore = 0;
        
        const safeFormData = formData || {};
        
        // Required field rules with weights
        const requiredFields = [
            { field: 'client_id', name: 'Facility', weight: 10, critical: true },
            { field: 'item_id', name: 'Asset Name', weight: 10, critical: true },
            { field: 'functional_status', name: 'Status', weight: 8, critical: true },
            { field: 'station_point_ids', name: 'Current Location', weight: 8, critical: true }
        ];

        // Asset-specific required fields
        if (assetCatId === '8') {
            requiredFields.push({ field: 'serial_no', name: 'Registration Plate', weight: 10, critical: true });
        }
        
        if (assetCatId === '2' || assetCatId === '3' || assetCatId === '9') {
            requiredFields.push({ field: 'qty', name: 'Quantity', weight: 8, critical: false });
        }

        // Check required fields
        requiredFields.forEach(rule => {
            maxScore += rule.weight;
            const value = safeFormData[rule.field];
            const isComplete = Array.isArray(value) ? value.length > 0 : value && value.toString().trim() !== '';
            
            if (isComplete) {
                totalScore += rule.weight;
                rules.push({
                    type: 'success',
                    field: rule.field,
                    message: `${rule.name} provided`,
                    weight: rule.weight,
                    critical: rule.critical
                });
            } else {
                rules.push({
                    type: rule.critical ? 'error' : 'warning',
                    field: rule.field,
                    message: `${rule.name} ${rule.critical ? 'required' : 'recommended'}`,
                    weight: rule.weight,
                    critical: rule.critical
                });
            }
        });

        // Format validation - Registration plate
        if (assetCatId === '8' && safeFormData.serial_no) {
            const plateRegex = /^[A-Z]{3}\s[A-Z0-9]{3}\s[A-Z0-9]{1,5}$/;
            const weight = 5;
            maxScore += weight;
            
            if (plateRegex.test(safeFormData.serial_no)) {
                totalScore += weight;
                formatRules.push({
                    type: 'success',
                    field: 'serial_no',
                    message: 'Registration plate format is correct',
                    weight: weight,
                    critical: false
                });
            } else {
                formatRules.push({
                    type: 'warning',
                    field: 'serial_no',
                    message: 'Registration plate should follow format: XXX XXX XXXXX',
                    weight: weight,
                    critical: false
                });
            }
        }

        // Quantity validation
        if ((assetCatId === '2' || assetCatId === '3' || assetCatId === '9') && safeFormData.qty) {
            const weight = 3;
            maxScore += weight;
            const qty = parseInt(safeFormData.qty);
            
            if (qty > 0 && qty <= 10000) {
                totalScore += weight;
                formatRules.push({
                    type: 'success',
                    field: 'qty',
                    message: 'Quantity is within reasonable range',
                    weight: weight,
                    critical: false
                });
            } else {
                formatRules.push({
                    type: 'warning',
                    field: 'qty',
                    message: 'Quantity should be between 1 and 10,000',
                    weight: weight,
                    critical: false
                });
            }
        }

        // Bonus rules
        if (safeFormData.installation_date) {
            const weight = 5;
            maxScore += weight;
            totalScore += weight;
            bonusRules.push({
                type: 'success',
                field: 'installation_date',
                message: 'Installation date provided (improves tracking)',
                weight: weight,
                critical: false
            });
        } else {
            const weight = 5;
            maxScore += weight;
            bonusRules.push({
                type: 'info',
                field: 'installation_date',
                message: 'Installation date recommended for better tracking',
                weight: weight,
                critical: false
            });
        }

        // Comments bonus
        if (safeFormData.eicomment && safeFormData.eicomment.length >= 10) {
            const weight = 3;
            maxScore += weight;
            totalScore += weight;
            bonusRules.push({
                type: 'success',
                field: 'eicomment',
                message: 'Detailed remarks provided',
                weight: weight,
                critical: false
            });
        } else {
            const weight = 3;
            maxScore += weight;
            bonusRules.push({
                type: 'info',
                field: 'eicomment',
                message: 'Detailed remarks help with asset management',
                weight: weight,
                critical: false
            });
        }

        // Data source bonus
        if (safeFormData.data_source) {
            const weight = 4;
            maxScore += weight;
            totalScore += weight;
            bonusRules.push({
                type: 'success',
                field: 'data_source',
                message: 'Data source specified (improves reliability)',
                weight: weight,
                critical: false
            });
        } else {
            const weight = 4;
            maxScore += weight;
            bonusRules.push({
                type: 'info',
                field: 'data_source',
                message: 'Data source helps verify information accuracy',
                weight: weight,
                critical: false
            });
        }

        // Photos bonus
        if (safeFormData.photos && safeFormData.photos.length > 0) {
            const weight = 6;
            maxScore += weight;
            totalScore += weight;
            bonusRules.push({
                type: 'success',
                field: 'photos',
                message: `${safeFormData.photos.length} photo(s) attached (excellent documentation)`,
                weight: weight,
                critical: false
            });
        } else {
            const weight = 6;
            maxScore += weight;
            bonusRules.push({
                type: 'info',
                field: 'photos',
                message: 'Photos help with asset identification and condition tracking',
                weight: weight,
                critical: false
            });
        }

        const percentage = maxScore > 0 ? Math.round((totalScore / maxScore) * 100) : 0;
        
        const allRules = [
            ...rules.filter(r => r && typeof r === 'object'), 
            ...formatRules.filter(r => r && typeof r === 'object'), 
            ...bonusRules.filter(r => r && typeof r === 'object')
        ];
        
        // Determine overall quality level
        let qualityLevel = 'Very Poor';
        let qualityColor = '#dc2626';
        if (percentage >= 90) {
            qualityLevel = 'Excellent';
            qualityColor = '#22c55e';
        } else if (percentage >= 75) {
            qualityLevel = 'Good';
            qualityColor = '#3b82f6';
        } else if (percentage >= 60) {
            qualityLevel = 'Fair';
            qualityColor = '#f59e0b';
        } else if (percentage >= 40) {
            qualityLevel = 'Poor';
            qualityColor = '#ef4444';
        }

        return {
            percentage,
            totalScore,
            maxScore,
            rules: allRules,
            qualityLevel,
            qualityColor,
            criticalIssues: allRules.filter(r => r && r.critical === true && r.type === 'error').length
        };
    }, [formData, assetCatId]);
};

// ==================== REGISTRATION PLATE FORMATTER ====================
const formatRegistrationPlate = (value, previousValue = '') => {
    const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    
    if (value.length < previousValue.length) {
        return value.replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase().substring(0, 14);
    }
    
    let formatted = '';
    if (cleanValue.length > 0) {
        formatted = cleanValue.substring(0, 3);
        if (cleanValue.length > 3) {
            formatted += ' ' + cleanValue.substring(3, 6);
            if (cleanValue.length > 6) {
                formatted += ' ' + cleanValue.substring(6, 12);
            }
        }
    }
    
    return formatted;
};

// ==================== MAIN ADDFORM COMPONENT ====================

// ══════════════════════════════════════════════════════════════════════════════
// VerifyVehicleModal — data collector confirms vehicle details on the ground
// Opens from the verify (✓) button on pending vehicle rows
// ══════════════════════════════════════════════════════════════════════════════
const VerifyVehicleModal = ({ vehicle, clients, stationPoints, functionalStatus, onDone, onClose }) => {
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        client_id:            vehicle?.client_id            || null,
        station_point_ids:    vehicle?.station_point_ids    || null,
        functional_status:    vehicle?.functional_status    || null,
        delivery_note_number: vehicle?.delivery_note_number || '',   // mileage
        eicomment:            vehicle?.eicomment            || '',   // engine no
        order_number:         vehicle?.order_number         || '',   // chassis
        serial_no:            vehicle?.serial_no            || '',   // plate
        eimonth:              vehicle?.eimonth              || '',   // model year
        eistatus:             vehicle?.eistatus             || '',   // maintenance
        // ── Phase 3 fleet fields ──
        fuel_type:            vehicle?.fuel_type            || '',
        region:               vehicle?.region               || '',
        assigned_programme:   vehicle?.assigned_programme   || '',
        private_ref_old_reg:  vehicle?.private_ref_old_reg  || '',
        engine_capacity_cc:   vehicle?.engine_capacity_cc   || '',
        colour:               vehicle?.colour               || '',
        condition_rating:     vehicle?.condition_rating      || '',
        procurement_method:   vehicle?.procurement_method   || '',
        funded_by:            vehicle?.funded_by            || '',
    });

    // Re-initialise form whenever the vehicle prop changes
    useEffect(() => {
        if (vehicle) {
            setForm({
                client_id:            vehicle.client_id        || null,
                station_point_ids:    vehicle.station_point_ids || null,
                functional_status:    vehicle.functional_status || null,
                delivery_note_number: vehicle.delivery_note_number || '',
                eicomment:            vehicle.eicomment         || '',
                eieftnumber:          vehicle.eieftnumber        || '',
                order_number:         vehicle.order_number       || '',
                serial_no:            vehicle.serial_no         || '',
                eimonth:              vehicle.eimonth            || '',
                eistatus:             vehicle.eistatus           || '',
                // ── Phase 3 fleet fields ──
                fuel_type:            vehicle.fuel_type            || '',
                region:               vehicle.region               || '',
                assigned_programme:   vehicle.assigned_programme   || '',
                private_ref_old_reg:  vehicle.private_ref_old_reg  || '',
                engine_capacity_cc:   vehicle.engine_capacity_cc   || '',
                colour:               vehicle.colour               || '',
                condition_rating:     vehicle.condition_rating      || '',
                procurement_method:   vehicle.procurement_method   || '',
                funded_by:            vehicle.funded_by            || '',
            });
        }
    }, [vehicle]);

    const handleChange = (val, key) => {
        if (key === 'client_id') {
            // Clear location when facility changes — old location belongs to old facility
            setForm(prev => ({ ...prev, client_id: val, station_point_ids: null }));
        } else {
            setForm(prev => ({ ...prev, [key]: val }));
        }
    };

    // Vehicle station points for selected facility
    const vehicleSPs = stationPoints.filter(sp => {
        const linkedToFacility = form.client_id && sp.client_ids && sp.client_ids.includes(form.client_id);
        const isVehicleSP = sp.asset_cat_ids &&
            sp.asset_cat_ids.toString().split(',').map(s => s.trim()).includes('8');
        return linkedToFacility && isVehicleSP;
    });

    const doVerify = async () => {
        if (!form.client_id)         { message.error('Please select a facility'); return; }
        if (!form.station_point_ids) { message.error('Please select the vehicle location'); return; }
        if (!form.functional_status) { message.error('Please select vehicle status'); return; }
        setSaving(true);
        try {
            await AssetService.save({
                id:                   vehicle.id,
                client_id:            parseInt(form.client_id),
                item_id:              vehicle.item_id,
                station_point_ids:    parseInt(form.station_point_ids),
                functional_status:    form.functional_status,
                serial_no:            form.serial_no,        // plate stays as-is (read-only)
                order_number:         form.order_number,
                eicomment:            form.eicomment,
                eieftnumber:          form.eieftnumber,
                eimonth:              form.eimonth,
                delivery_note_number: form.delivery_note_number,
                eistatus:             form.eistatus,
                verification_status:  'verified',
                qty: 1,
                cost: vehicle.cost || 0,
                isdonated: vehicle.isdonated || 0,
                // ── Phase 3 fleet fields ──
                fuel_type:            form.fuel_type,
                region:               form.region,
                assigned_programme:   form.assigned_programme,
                private_ref_old_reg:  form.private_ref_old_reg,
                engine_capacity_cc:   form.engine_capacity_cc,
                colour:               form.colour,
                condition_rating:     form.condition_rating,
                procurement_method:   form.procurement_method,
                funded_by:            form.funded_by,
            });
            message.success('Vehicle verified and deployed successfully');
            onDone();
        } catch(e) {
            message.error(e?.response?.data?.message || e.message || 'Failed to save');
        } finally { setSaving(false); }
    };

    const doNotFound = async () => {
        Modal.confirm({
            title: 'Mark as Not Found?',
            content: 'This will flag the vehicle as unlocated during ground verification. You can add a note below.',
            okText: 'Mark Not Found',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: async () => {
                setSaving(true);
                try {
                    await AssetService.save({
                        id:                  vehicle.id,
                        client_id:           parseInt(vehicle.client_id),
                        item_id:             vehicle.item_id,
                        station_point_ids:   vehicle.station_point_ids ? parseInt(vehicle.station_point_ids) : null,
                        functional_status:   vehicle.functional_status || '1',
                        verification_status: 'not_found',
                        qty: 1,
                        cost: vehicle.cost || 0,
                        isdonated: vehicle.isdonated || 0,
                    });
                    message.warning('Vehicle marked as not found');
                    onDone();
                } catch(e) {
                    message.error(e?.response?.data?.message || e.message || 'Failed to save');
                } finally { setSaving(false); }
            }
        });
    };

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Tag color="orange" style={{ marginRight: 0 }}>Pending Verification</Tag>
                    <span style={{ fontSize: 15, fontWeight: 600 }}>
                        {vehicle?.serial_no} — {vehicle?.item}
                    </span>
                </div>
            }
            open={!!vehicle}
            onCancel={onClose}
            width={680}
            footer={null}
            destroyOnClose
        >
            <Alert
                message="Data Collector — confirm the vehicle details on the ground"
                description="Update any incorrect details, confirm the exact current location and facility, then click Verify & Deploy."
                type="info"
                showIcon
                style={{ marginBottom: 20 }}
            />

            {/* ── Section 1: Facility & Location ── */}
            <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: '14px 16px', marginBottom: 16 }}>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#389e0d' }}>📍 Confirm Location</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Facility <span style={{ color: 'red' }}>*</span></div>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={form.client_id}
                                onChange={v => handleChange(v, 'client_id')}
                                placeholder="Select facility"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {clients.map(c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>)}
                            </Select>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Current Location <span style={{ color: 'red' }}>*</span></div>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={form.station_point_ids}
                                onChange={v => handleChange(v, 'station_point_ids')}
                                placeholder="Select location"
                                disabled={!form.client_id}
                            >
                                {vehicleSPs.map(sp => <Select.Option key={sp.id} value={sp.id}>{sp.name}</Select.Option>)}
                            </Select>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* ── Section 2: Vehicle Status ── */}
            <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 6, padding: '14px 16px', marginBottom: 16 }}>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#d46b08' }}>🚗 Vehicle Status & Mileage</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Status <span style={{ color: 'red' }}>*</span></div>
                            <AntdSelect
                                showSearch
                                style={{ width: '100%' }}
                                options={functionalStatus.filter(s => [
                                    'Good condition',
                                    'Fair',
                                    'Waiting for repairs',
                                    'Awaiting for disposal',
                                    'TBC'
                                ].includes(s.name))}
                                value={form.functional_status}
                                onChange={v => handleChange(v, 'functional_status')}
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Mileage (km)</div>
                            <Input
                                value={form.delivery_note_number}
                                onChange={e => handleChange(e.target.value, 'delivery_note_number')}
                                placeholder="Current mileage"
                            />
                        </div>
                    </Col>
                </Row>
            </div>

            {/* ── Section 3: Vehicle Details (read/edit) ── */}
            <div style={{ background: '#f0f5ff', border: '1px solid #adc6ff', borderRadius: 6, padding: '14px 16px', marginBottom: 20 }}>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#2f54eb' }}>🔧 Confirm Vehicle Details</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                Registration Plate
                                <span style={{ marginLeft: 6, fontSize: 11, color: '#fa8c16', fontWeight: 500 }}>
                                    (read-only — use this to identify the vehicle)
                                </span>
                            </div>
                            <Input
                                value={form.serial_no}
                                disabled
                                style={{ background: '#f5f5f5', color: '#333', fontWeight: 600, letterSpacing: 1 }}
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Engine Number</div>
                            <Input
                                value={form.eieftnumber}
                                onChange={e => handleChange(e.target.value, 'eieftnumber')}
                                placeholder="Engine number"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Chassis Number</div>
                            <Input
                                value={form.order_number}
                                onChange={e => handleChange(e.target.value, 'order_number')}
                                placeholder="Chassis / VIN"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Model Year</div>
                            <Input
                                value={form.eimonth}
                                onChange={e => handleChange(e.target.value, 'eimonth')}
                                placeholder="e.g. 2019"
                            />
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ marginBottom: 4 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Maintenance Needs</div>
                            <select
                                className="form-control"
                                value={form.eistatus}
                                onChange={e => handleChange(e.target.value, 'eistatus')}
                                style={{ width: '100%' }}
                            >
                                <option value="">None / No service needed</option>
                                <option value="Minor service">Minor service</option>
                                <option value="Major service">Major service</option>
                            </select>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ marginBottom: 4 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Remarks / Comments</div>
                            <Input.TextArea
                                rows={3}
                                value={form.eicomment}
                                onChange={e => handleChange(e.target.value, 'eicomment')}
                                placeholder="Enter any observations, notes, or comments about this vehicle..."
                                style={{ resize: 'vertical' }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>

            {/* ── Section 4: Fleet Register Fields ── */}
            <div style={{ background: '#fff0f6', border: '1px solid #ffadd2', borderRadius: 6, padding: '14px 16px', marginBottom: 20 }}>
                <div style={{ fontWeight: 600, marginBottom: 12, color: '#c41d7f' }}>🗂 Fleet Register Details</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Region</div>
                            <select className="form-control" value={form.region} onChange={e => handleChange(e.target.value, 'region')}>
                                <option value="">Select region</option>
                                {['Hhohho','Manzini','Shiselweni','Lubombo','National'].map(r =>
                                    <option key={r} value={r}>{r}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Assigned Programme</div>
                            <Input
                                value={form.assigned_programme}
                                onChange={e => handleChange(e.target.value, 'assigned_programme')}
                                placeholder="e.g. PEPFAR, GFATM, EPI"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Old Reg / Private Ref</div>
                            <Input
                                value={form.private_ref_old_reg}
                                onChange={e => handleChange(e.target.value, 'private_ref_old_reg')}
                                placeholder="Previous registration plate"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Engine Capacity (cc)</div>
                            <Input
                                type="number"
                                value={form.engine_capacity_cc}
                                onChange={e => handleChange(e.target.value, 'engine_capacity_cc')}
                                placeholder="e.g. 2500"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Fuel Type</div>
                            <select className="form-control" value={form.fuel_type} onChange={e => handleChange(e.target.value, 'fuel_type')}>
                                <option value="">Select fuel type</option>
                                <option value="Diesel">Diesel</option>
                                <option value="Petrol">Petrol</option>
                                <option value="Hybrid">Hybrid</option>
                                <option value="Electric">Electric</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Colour</div>
                            <Input
                                value={form.colour}
                                onChange={e => handleChange(e.target.value, 'colour')}
                                placeholder="e.g. White"
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Condition Rating (1–5)</div>
                            <select className="form-control" value={form.condition_rating} onChange={e => handleChange(e.target.value, 'condition_rating')}>
                                <option value="">Select rating</option>
                                <option value="5">5 — Excellent</option>
                                <option value="4">4 — Good</option>
                                <option value="3">3 — Fair</option>
                                <option value="2">2 — Poor</option>
                                <option value="1">1 — Very Poor</option>
                            </select>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Procurement Method</div>
                            <select className="form-control" value={form.procurement_method} onChange={e => handleChange(e.target.value, 'procurement_method')}>
                                <option value="">Select method</option>
                                {['Direct Purchase','Tender','Donation','Transfer','Other'].map(m =>
                                    <option key={m} value={m}>{m}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Funded By</div>
                            <select className="form-control" value={form.funded_by} onChange={e => handleChange(e.target.value, 'funded_by')}>
                                <option value="">Select funder</option>
                                {['Government of Eswatini','PEPFAR','GFATM','WHO','UNICEF','World Bank','Other'].map(f =>
                                    <option key={f} value={f}>{f}</option>
                                )}
                            </select>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* ── Action buttons ── */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                    danger
                    onClick={doNotFound}
                    loading={saving}
                    style={{ borderRadius: 6 }}
                >
                    🔴 Not Found on Ground
                </Button>
                <div style={{ display: 'flex', gap: 10 }}>
                    <Button onClick={onClose} disabled={saving}>Cancel</Button>
                    <Button
                        type="primary"
                        onClick={doVerify}
                        loading={saving}
                        style={{ background: '#389e0d', borderColor: '#389e0d', borderRadius: 6 }}
                    >
                        ✅ Verify & Deploy
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

const AddForm = forwardRef((props, ref) => {
    const { 
        callback, 
        pageno, 
        clients, 
        stationPoints, 
        functionalStatus, 
        cat_type, 
        items,
        isNational,
        asset_cat_id 
    } = props;

    // State Management
    const [showForm, setShowForm] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [data, setData] = useState({ isdonated: 0, photos: [] });
    const [bulkData, setBulkData] = useState([]);
    const [currentPhotos, setCurrentPhotos] = useState([]);
    const [showQualityPanel, setShowQualityPanel] = useState(true);
    const [showSmartImport, setShowSmartImport] = useState(false);
    const [saving, setSaving] = useState(false);

    // Calculate data quality score
    const qualityScore = useDataQualityScore(isEditMode ? data : {}, asset_cat_id);
const [bulkDuplicateCheck, setBulkDuplicateCheck] = useState({
    checking: false,
    results: []
});
    // Filter statuses based on asset category
    const filteredStatuses = useMemo(() => {
        return functionalStatus.filter(status => {
            if (asset_cat_id === '8') {
                const excludedFor8 = [
                    'Not installed', 'Functional', 'Boarded', 
                    'Non functional', 'Installed', 'Partial functional',
                    'Usable', 'Expired'
                ];
                return !excludedFor8.includes(status.name);
            }
            
            if (asset_cat_id === '9') {
                const excludedFor9 = [
                    'Good condition', 'Fair', 'Awaiting for disposal',
                    'Waiting for repairs', 'Not installed', 'Functional',
                    'Boarded', 'Non functional', 'Installed', 'Partial functional'
                ];
                return !excludedFor9.includes(status.name);
            }
            
            if (asset_cat_id === '3' || asset_cat_id === '2') {
                const excludedFor3And2 = [
                    'Good condition', 'Fair', 'Awaiting for disposal',
                    'Waiting for repairs', 'Usable', 'Expired'
                ];
                return !excludedFor3And2.includes(status.name);
            }
            
            return true;
        });
    }, [functionalStatus, asset_cat_id]);

    // Handle form field changes
    const handleChange = (v, k) => {
        setData(prev => ({ ...prev, [k]: v }));
    };

    // Handle photo changes
    const handlePhotosChange = (photos) => {
        setCurrentPhotos(photos);
        setData(prev => ({
            ...prev,
            photos: photos.filter(photo => photo.isNew)
        }));
    };

    // Handle bulk data changes
    const handleBulkChange = (value, rowIndex, field) => {
        setBulkData(prev => {
            const newBulkData = [...prev];
            newBulkData[rowIndex] = { ...newBulkData[rowIndex], [field]: value };
            if (field === 'item_id') {
                newBulkData[rowIndex].qty = 1;
                newBulkData[rowIndex].cost = 0.00;
            }
            if (field === 'client_id') {
                newBulkData[rowIndex].station_point_ids = [];
            }
            return newBulkData;
        });
    };

    // Add new row in bulk mode
    const addNewRow = () => {
        const lastRowFacility = bulkData.length > 0 ? bulkData[bulkData.length - 1].client_id : null;
        const lastRowStationpoint = bulkData.length > 0 ? bulkData[bulkData.length - 1].station_point_ids : null;
        
        const newRow = {
            id: Date.now(),
            client_id: lastRowFacility,
            item_id: null,
            serial_no: '',
            qty: 1,
            cost: 0.00,
            functional_status: '',
            station_point_ids: lastRowStationpoint,
            eicomment: '',
            order_number: '',
            delivery_note_number: '',
            eimonth: '',
            procurement_date: null,
            installation_date: null,
            eistatus: '',
            data_source: '',
            isdonated: 0,
            donor_name: '',
            eibatchnumber: ''  // Added for supplies
        };
        setBulkData([...bulkData, newRow]);
    };

    // Remove row from bulk data
    const removeRow = (index) => {
        const newBulkData = bulkData.filter((_, i) => i !== index);
        setBulkData(newBulkData);
    };

    // Validate asset data
    const validateAsset = (asset) => {
        const errors = [];
        
        if (!asset.client_id) errors.push('Facility Name is required');
        if (!asset.item_id) errors.push('Asset Name is required');
        if (!asset.functional_status) errors.push('Status is required');

        // Location is optional for vehicles pending ground verification
        const isPendingVerification = asset.verification_status === 'pending';
        if (!isPendingVerification && !asset.station_point_ids) {
            errors.push('Current location is required');
        }
        
        if (asset_cat_id === '8' && !asset.serial_no) {
            errors.push('Registration Plate is required');
        }
        
        return errors;
    };

    // Handle Excel Import
    const handleExcelImport = async (importedData) => {
        try {
            const convertedData = importedData.map(row => ({
                id: Date.now() + Math.random(),
                client_id: row.client_id,
                item_id: row.item_id,
                serial_no: row.serial_no || '',
                qty: row.qty || 1,
                cost: row.cost || 0,
                functional_status: row.functional_status,
                station_point_ids: row.station_point_ids || [],
                eicomment: row.eicomment || '',
                eieftnumber: row.eieftnumber || '',
                order_number: row.order_number || '',
                delivery_note_number: row.delivery_note_number || '',
                eimonth: row.eimonth || '',
                procurement_date: row.procurement_date,
                installation_date: row.installation_date,
                eistatus: row.eistatus || '',
                data_source: row.data_source || '',
                isdonated: row.isdonated || 0,
                donor_name: row.donor_name || '',
                eibatchnumber: row.eibatchnumber || '',
                // Pass verification_status from import — 'pending' when location TBC
                verification_status: row.verification_status || null
            }));

            setBulkData(convertedData);
            setShowSmartImport(false);
            message.success(`Imported ${convertedData.length} assets from Excel`);
        } catch (error) {
            message.error('Failed to import Excel data: ' + error.message);
        }
    };
const checkBulkDuplicates = async () => {
    try {
        setBulkDuplicateCheck({ checking: true, results: [] });
        
        const response = await AssetService.batchCheckDuplicates(bulkData);
        
        if (response.data.data) {
            const duplicatesFound = response.data.data.filter(r => r.has_duplicates);
            
            if (duplicatesFound.length > 0) {
                setBulkDuplicateCheck({ 
                    checking: false, 
                    results: response.data.data 
                });
                
                Modal.warning({
                    title: 'Duplicates Detected in Bulk Data',
                    width: 700,
                    content: (
                        <div>
                            <p>{duplicatesFound.length} rows have potential duplicates:</p>
                            {duplicatesFound.map((result, i) => (
                                <Alert
                                    key={i}
                                    message={`Row ${result.index + 1}`}
                                    description={`${result.duplicates.length} duplicate(s) found - Risk: ${result.risk_level.toUpperCase()}`}
                                    type="warning"
                                    showIcon
                                    style={{ marginBottom: 8 }}
                                />
                            ))}
                            <p style={{ marginTop: 12 }}>
                                Review and remove duplicates before saving.
                            </p>
                        </div>
                    )
                });
            } else {
                message.success('No duplicates detected in bulk data');
            }
        }
    } catch (error) {
        message.error('Failed to check for duplicates: ' + error.message);
    } finally {
        setBulkDuplicateCheck(prev => ({ ...prev, checking: false }));
    }
};
    // Save function
    const save = async () => {
    message.destroy();
    
    // Check critical issues before saving in edit mode
    if (isEditMode && qualityScore.criticalIssues > 0) {
        const proceed = await new Promise((resolve) => {
            Modal.confirm({
                title: 'Data Quality Warning',
                content: `You have ${qualityScore.criticalIssues} critical issue(s) remaining. Your current quality score is ${qualityScore.percentage}%. Do you want to save anyway?`,
                okText: 'Save Anyway',
                cancelText: 'Fix Issues First',
                onOk: () => resolve(true),
                onCancel: () => resolve(false)
            });
        });
        
        if (!proceed) return;
    }
    
    setSaving(true);
    
    if (isEditMode) {
        // Single asset save
        try {
            const saveData = {
                ...data,
                // station_point_ids is now a single value, not an array
                station_point_ids: data.station_point_ids ? parseInt(data.station_point_ids) : null,
                // Include batch number for supplies
                ...(asset_cat_id === '9' && data.eibatchnumber && { eibatchnumber: data.eibatchnumber }),
                // Verification fields — set by import or ground discovery toggle
                ...(data.verification_status && { verification_status: data.verification_status }),
                ...(data.data_source !== undefined && { data_source: data.data_source }),
                ...(data.eieftnumber && { eieftnumber: data.eieftnumber }),
            };
            
            const response = await AssetService.save(saveData);
            message.success(response.data.message || 'Saved');
            callback(response.data.asset_id ? pageno : 1);
            setShowForm(false);
        } catch (error) {
            message.error(error.message || 'Failed to save asset');
            console.error('Save error:', error);
        }
    } else {
        // Bulk save
        const validAssets = bulkData.filter(asset => asset.client_id && asset.item_id);
        
        if (validAssets.length === 0) {
            message.error('Please add at least one valid asset with Facility and Asset Name selected');
            setSaving(false);
            return;
        }
        
        const allErrors = [];
        validAssets.forEach((asset, index) => {
            const errors = validateAsset(asset);
            if (errors.length > 0) {
                allErrors.push(`Row ${index + 1}: ${errors.join(', ')}`);
            }
        });
        
        if (allErrors.length > 0) {
            message.error(`Please fix the following errors:\n${allErrors.join('\n')}`);
            setSaving(false);
            return;
        }
        
        try {
            let successCount = 0;
            let errorCount = 0;
            const errorMessages = [];
            
            for (let i = 0; i < validAssets.length; i++) {
                const asset = validAssets[i];
                
                try {
                    const cleanAsset = {
                        ...(asset.id && !asset.id.toString().startsWith('17') ? { id: asset.id } : {}),
                        client_id: parseInt(asset.client_id),
                        item_id: parseInt(asset.item_id),
                        // Station point is now single value
                        station_point_ids: asset.station_point_ids ? parseInt(asset.station_point_ids) : null,
                        // functional_status MUST always be sent — backend requires it
                        functional_status: asset.functional_status || '1',
                        ...(asset.serial_no && { serial_no: asset.serial_no }),
                        ...(asset.order_number && { order_number: asset.order_number }),
                        ...(asset.delivery_note_number && { delivery_note_number: asset.delivery_note_number }),
                        ...(asset.eimonth && { eimonth: asset.eimonth }),
                        ...(asset.procurement_date && { procurement_date: asset.procurement_date }),
                        ...(asset.installation_date && { installation_date: asset.installation_date }),
                        ...(asset.eistatus && { eistatus: asset.eistatus }),
                        ...(asset.eicomment && { eicomment: asset.eicomment }),
                        ...(asset.eieftnumber && { eieftnumber: asset.eieftnumber }),
                        // verification_status — vehicles are always pending on import
                        verification_status: asset.verification_status || 'pending',
                        data_source: asset.data_source || '',
                        // Add batch number for supplies
                        ...(asset_cat_id === '9' && asset.eibatchnumber && { eibatchnumber: asset.eibatchnumber }),
                        qty: asset.qty ? parseInt(asset.qty) : 1,
                        cost: asset.cost ? parseFloat(asset.cost) : 0.00,
                        ...(asset.data_source && { data_source: asset.data_source }),
                        isdonated: asset.isdonated ? parseInt(asset.isdonated) : 0,
                        ...(asset.isdonated === '1' && asset.donor_name && { donor_name: asset.donor_name })
                    };
                    
                    if (!cleanAsset.id) {
                        cleanAsset.added_by_client_id = props.isNational ? asset.client_id : window.CLIENT_ID || 1;
                    }
                    
                    await AssetService.save(cleanAsset);
                    successCount++;
                } catch (error) {
                    errorCount++;
                    let errorMsg = 'Unknown error';
                    if (error.response?.data?.message) {
                        errorMsg = error.response.data.message;
                    } else if (error.message) {
                        errorMsg = error.message;
                    }
                    errorMessages.push(`Row ${i + 1}: ${errorMsg}`);
                    console.error('Failed to save asset:', error);
                }
            }
            
            if (successCount > 0) {
                let msg = `${successCount} asset(s) saved successfully`;
                if (errorCount > 0) {
                    msg += `\n\nErrors (${errorCount}):\n${errorMessages.join('\n')}`;
                }
                
                if (errorCount === 0) {
                    message.success(msg);
                    callback(1);
                    setShowForm(false);
                } else {
                    message.warning(msg);
                }
            } else {
                message.error(`Failed to save any assets:\n${errorMessages.join('\n')}`);
            }
        } catch (error) {
            message.error('Error during bulk save operation');
            console.error('Bulk save error:', error);
        }
    }
    
    setSaving(false);
};

    // Close form
    const closeForm = () => {
        setShowForm(false);
        setBulkData([]);
        setCurrentPhotos([]);
        setShowQualityPanel(false);
    };

    // Expose openForm method to parent
    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            let client_id = null;
            const myFacility = clients.find(v => v.is_me);
            client_id = myFacility?.id;

            if (dtl) {
                setIsEditMode(true);
                const stationPointId = Array.isArray(dtl.station_point_ids) 
            ? (dtl.station_point_ids.length > 0 ? dtl.station_point_ids[0] : null)
            : dtl.station_point_ids;
                 setData({ 
            ...dtl, 
            station_point_ids: stationPointId  // Single value instead of array
        });
                setBulkData([]);
                setCurrentPhotos([]);
                if (dtl.id) {
                    loadExistingPhotos(dtl.id);
                }
            } else {
                setIsEditMode(false);
                setData({ 
                    station_point_ids: null, 
                    functional_status: '1', 
                    client_id, 
                    photos: [] 
                });
                setCurrentPhotos([]);
                setBulkData([{
                    id: Date.now(),
                    client_id,
                    item_id: null,
                    serial_no: '',
                    qty: 1,
                    cost: 0.00,
                    functional_status: '',
                    station_point_ids: null,
                    eicomment: '',
                    order_number: '',
                    delivery_note_number: '',
                    eimonth: '',
                    procurement_date: null,
                    installation_date: null,
                    eistatus: '',
                    data_source: '',
                    isdonated: 0,
                    donor_name: '', 
                    eibatchnumber: ''  // Added for supplies
                }]);
            }
            setShowForm(true);
            setShowQualityPanel(true);
        }
    }));

    // Load existing photos for editing
    const loadExistingPhotos = async (assetId) => {
        try {
            let response;
            try {
                response = await AssetService.getAssetPhotos(assetId);
            } catch (error) {
                console.log('AssetService.getAssetPhotos not available, using fallback');
                if (data.photos && Array.isArray(data.photos)) {
                    setCurrentPhotos(data.photos);
                    return;
                }
                setCurrentPhotos([]);
                return;
            }
            
            let photoData = [];
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                photoData = response.data.data;
            } else if (response.data && Array.isArray(response.data)) {
                photoData = response.data;
            } else {
                console.log('No photos found or unexpected format:', response.data);
                setCurrentPhotos([]);
                return;
            }
            
            const existingPhotos = photoData.map((photo, index) => ({
                uid: `existing_${index}`,
                name: photo.original_filename || `Photo ${index + 1}`,
                status: 'done',
                url: `http://localhost/asset/${photo.photo_path}`,
                path: photo.photo_path,
                isNew: false
            }));
            setCurrentPhotos(existingPhotos);
        } catch (error) {
            console.error('Error loading photos:', error);
            setCurrentPhotos([]);
        }
    };

    // Get table columns for bulk mode
    const getTableColumns = () => {
        const baseColumns = [
            {
                title: 'Facility Name',
                dataIndex: 'client_id',
                width: 250,
                render: (value, record, index) => (
                    <AntdSelect
                        showSearch
                        options={clients}
                        value={value}
                        onChange={v => handleBulkChange(v, index, 'client_id')}
                        style={{ width: '100%' }}
                        placeholder="Select facility"
                    />
                )
            },
            {
                title: 'Asset Name',
                dataIndex: 'item_id',
                width: 280,
                render: (value, record, index) => (
                    <AntdSelect
                        showSearch
                        options={items.map(v => ({ id: v.id, name: v.item_full_name }))}
                        value={value}
                        onChange={v => handleBulkChange(v, index, 'item_id')}
                        style={{ width: '100%' }}
                        placeholder="Select asset"
                    />
                )
            }
        ];

        if (asset_cat_id === '8') {
            baseColumns.push(
                {
                    title: 'Registration Plate',
                    dataIndex: 'serial_no',
                    width: 180,
                    render: (value, record, index) => (
                        <Input
                            value={value || ''}
                            onChange={e => {
                                const formatted = formatRegistrationPlate(e.target.value, value || '');
                                handleBulkChange(formatted, index, 'serial_no');
                            }}
                            placeholder="GSD 123 UN"
                            maxLength={14}
                        />
                    )
                },
                {
                    title: 'Engine Number',
                    dataIndex: 'eieftnumber',
                    width: 160,
                    render: (value, record, index) => (
                        <Input
                            value={value || ''}
                            onChange={e => handleBulkChange(e.target.value, index, 'eieftnumber')}
                            placeholder="Engine Number"
                        />
                    )
                },
                {
                    title: 'Chassis Number',
                    dataIndex: 'order_number',
                    width: 160,
                    render: (value, record, index) => (
                        <Input
                            value={value || ''}
                            onChange={e => handleBulkChange(e.target.value, index, 'order_number')}
                            placeholder="Chassis Number"
                        />
                    )
                },
                {
                    title: 'Date Registered',
                    dataIndex: 'procurement_date',
                    width: 160,
                    render: (value, record, index) => (
                        <AntdDatepicker
                            value={value}
                            onChange={v => handleBulkChange(v, index, 'procurement_date')}
                            style={{ width: '100%' }}
                        />
                    )
                }
            );
        } else if (asset_cat_id === '3') {
            baseColumns.push({
                title: 'Serial/Tag',
                dataIndex: 'serial_no',
                width: 150,
                render: (value, record, index) => (
                    <Input
                        value={value || ''}
                        onChange={e => handleBulkChange(e.target.value, index, 'serial_no')}
                    />
                )
            });
        }
         else if (asset_cat_id === '9') {
            baseColumns.push({
                title: 'Batch Number/Tag',
                dataIndex: 'eibatchnumber',
                width: 150,
                render: (value, record, index) => (
                    <Input
                        value={value || ''}
                        onChange={e => handleBulkChange(e.target.value, index, 'eibatchnumber')}
                    />
                )
            });
        }
        
        else
        {
        baseColumns.push({
                title: 'Batch Number/Tag',
                dataIndex: 'serial_no',
                width: 150,
                render: (value, record, index) => (
                    <Input
                        value={value || ''}
                        onChange={e => handleBulkChange(e.target.value, index, 'serial_no')}
                    />
                )
            });
        }

        const statusTitle = asset_cat_id === '8' ? 'Vehicle Status' : 
                           asset_cat_id === '9' ? 'Status' : 'Functional Status';
        
        baseColumns.push({
            title: statusTitle,
            dataIndex: 'functional_status',
            width: 180,
            render: (value, record, index) => (
                <AntdSelect
                    showSearch
                    options={filteredStatuses}
                    value={value}
                    onChange={v => handleBulkChange(v, index, 'functional_status')}
                    style={{ width: '100%' }}
                />
            )
        });

        if (asset_cat_id === '9') {
            baseColumns.push({
                title: 'Expiry Date',
                dataIndex: 'procurement_date',
                width: 160,
                render: (value, record, index) => (
                    <AntdDatepicker
                        value={value}
                        onChange={v => handleBulkChange(v, index, 'procurement_date')}
                        style={{ width: '100%' }}
                    />
                )
            });
        }
        if (asset_cat_id === '2') {
    baseColumns.push({
        title: 'Received Year',
        dataIndex: 'procurement_date',
        width: 140,
        render: (value, record, index) => (
            <DatePicker
                picker="year"
                value={value ? moment(value, 'YYYY') : null}
                onChange={(momentVal) => {
                    // Store only the 4-digit year string e.g. "2020"
                    handleBulkChange(
                        momentVal ? momentVal.format('YYYY') : null,
                        index,
                        'procurement_date'
                    );
                }}
                style={{ width: '100%' }}
                placeholder="Select year"
            />
        )
    });
}

        if (asset_cat_id === '8') {
            baseColumns.push(
                {
                    title: 'Mileage',
                    dataIndex: 'delivery_note_number',
                    width: 120,
                    render: (value, record, index) => (
                        <Input
                            value={value || ''}
                            onChange={e => handleBulkChange(e.target.value, index, 'delivery_note_number')}
                        />
                    )
                },
                {
                    title: 'Model Year',
                    dataIndex: 'eimonth',
                    width: 120,
                    render: (value, record, index) => (
                        <Input
                            value={value || ''}
                            onChange={e => handleBulkChange(e.target.value, index, 'eimonth')}
                        />
                    )
                },
                {
                    title: 'Maintenance Needs',
                    dataIndex: 'eistatus',
                    width: 180,
                    render: (value, record, index) => (
                        <select
                            className="form-control"
                            value={value || ''}
                            onChange={e => handleBulkChange(e.target.value, index, 'eistatus')}
                            style={{ width: '100%' }}
                        >
                            <option value="">Select maintenance type</option>
                            <option value="Minor service">Minor service</option>
                            <option value="Major service">Major service</option>
                        </select>
                    )
                }
            );
        }

        baseColumns.push(
            
            {
                title: 'Current Location',
                dataIndex: 'station_point_ids',
                width: 250,
                render: (value, record, index) => (
                    <AntdSelect
                        showSearch
                        //mode="multiple"
                        options={
                            asset_cat_id === '8'
                                ? stationPoints.filter(v => v.client_ids.includes(record.client_id) && v.asset_cat_ids && v.asset_cat_ids.toString().split(',').map(s=>s.trim()).includes('8'))
                                : stationPoints.filter(v => v.client_ids.includes(record.client_id) && (!v.asset_cat_ids || v.asset_cat_ids === ''))
                        }
                        value={value}
                        onChange={v => handleBulkChange(v, index, 'station_point_ids')}
                        style={{ width: '100%' }}
                        placeholder="Select location"
                    />
                )
            }
        );

        // ── Found on Ground column for vehicles ─────────────────────────
        if (asset_cat_id === '8') {
            baseColumns.push({
                title: '🔍 Found on Ground?',
                dataIndex: 'verification_status',
                width: 130,
                render: (value, record, index) => (
                    <div style={{ textAlign: 'center' }}>
                        <input
                            type="checkbox"
                            checked={record.data_source === 'ground_verification'}
                            onChange={e => {
                                if (e.target.checked) {
                                    handleBulkChange('ground_verification', index, 'data_source');
                                    handleBulkChange('found_at_facility', index, 'verification_status');
                                } else {
                                    handleBulkChange('', index, 'data_source');
                                    handleBulkChange('pending', index, 'verification_status');
                                }
                            }}
                            style={{ width: 16, height: 16, cursor: 'pointer' }}
                            title="Check if this vehicle was discovered during ground verification"
                        />
                        {record.data_source === 'ground_verification' && (
                            <div style={{ fontSize: 10, color: '#722ed1', marginTop: 2 }}>Found on ground</div>
                        )}
                    </div>
                )
            });
        }
        // ────────────────────────────────────────────────────────────────

if (asset_cat_id === '2' || asset_cat_id === '3' || asset_cat_id === '9') {
    baseColumns.push(
        {
            title: 'Quantity at hand',
            dataIndex: 'qty',
            width: 100,
            render: (value, record, index) => (
                <Input
                    type="number"
                    value={value}
                    onChange={e => handleBulkChange(e.target.value, index, 'qty')}
                />
            )
        },
        {
            title: 'Unit Cost (SZL)',
            dataIndex: 'cost',
            width: 120,
            render: (value, record, index) => (
                <Input
                    type="number"
                    value={value}
                    onChange={e => handleBulkChange(e.target.value, index, 'cost')}
                />
            )
        },
        
            {
                title: 'Remarks',
                dataIndex: 'eicomment',
                width: 200,
                render: (value, record, index) => (
                    <Input
                        value={value || ''}
                        onChange={e => handleBulkChange(e.target.value, index, 'eicomment')}
                    />
                )
            },
        {
            title: 'Is donated',
            dataIndex: 'isdonated',
            width: 120,
            render: (value, record, index) => (
                <AntdSelect
                    options={[{ label: 'No', value: '0' }, { label: 'Yes', value: '1' }]}
                    value={`${value || '0'}`}
                    onChange={v => handleBulkChange(v, index, 'isdonated')}
                    defaultValue="0"
                />
            )
        },
        {
            title: 'Donor Name',
            dataIndex: 'donor_name',
            width: 180,
            render: (value, record, index) => (
                record.isdonated === '1' ? (
                    <Input 
                        value={value || ''} 
                        onChange={e => handleBulkChange(e.target.value, index, 'donor_name')} 
                        placeholder="Specify Donor"
                    />
                ) : null
            )
        }
    );
}
        baseColumns.push(
            
            {
                title: 'Action',
                width: 80,
                fixed: 'right',
                render: (_, record, index) => (
                    <Popconfirm
                        title="Remove this row?"
                        onConfirm={() => removeRow(index)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            disabled={bulkData.length === 1}
                        />
                    </Popconfirm>
                )
            }

            
        );

        return baseColumns;
    };


    // Render edit mode form
    const renderEditMode = () => (
        <form onSubmit={e => { e.preventDefault(); save() }} autoComplete="off" spellCheck="false">
            <div className="">
                <div className="">
                    <label className="req">Facility Name</label>
                    <AntdSelect
                        showSearch
                        options={clients}
                        value={data.client_id}
                        disabled={data.id}
                        onChange={v => {
                            setData(prev => ({ ...prev, station_point_ids: null, client_id: v }));
                        }}
                    />
                </div>

                <Divider />

                <div className="row mingap">
                    <div className="col-md-12 form-group">
                        <label className="req">Asset Name</label>
                        <AntdSelect
                            showSearch
                            options={items.map(v => ({ id: v.id, name: v.item_full_name }))}
                            value={data.item_id}
                            disabled={data.id}
                            onChange={v => {
                                handleChange(v, 'item_id');
                                handleChange(1, 'stock');
                                handleChange(0.00, 'cost');
                            }}   
                        />
                    </div>

                    {/* Smart Duplicate Detection */}
                    <div className="col-md-12">
                        <SmartDuplicateDetector
                            formData={data}
                            assetCatId={asset_cat_id}
                            onViewAsset={(assetId) => {
                                console.log('View asset:', assetId);
                            }}
                        />
                    </div>

                    {/* SMART PHOTO CAPTURE */}
                    <div className="col-md-12 form-group">
                        <label>Asset Photos (AI-Powered)</label>
                        <SmartPhotoCapture
                            value={currentPhotos}
                            onChange={handlePhotosChange}
                            maxPhotos={5}
                            assetCatId={asset_cat_id}
                            onPlateDetected={(plate) => {
                                handleChange(plate, 'serial_no');
                                message.success('Registration plate auto-filled from photo!');
                            }}
                            onConditionDetected={(condition) => {
                                const status = filteredStatuses.find(s => 
                                    s.name === condition.condition
                                );
                                if (status) {
                                    handleChange(status.id, 'functional_status');
                                    message.success('Asset status suggested from photo analysis!');
                                }
                            }}
                        />
                    </div>
                    
                    {/* CATEGORY-SPECIFIC FIELDS */}
                    {asset_cat_id === '8' && (
                        <>
                            {/* ── Ground verification capture toggle ── */}
                            <div className="col-md-12 form-group" style={{ marginBottom: 12 }}>
                                <div style={{
                                    padding: '10px 14px',
                                    background: data.data_source === 'ground_verification' ? '#f9f0ff' : '#f6f6f6',
                                    border: `1px solid ${data.data_source === 'ground_verification' ? '#b37feb' : '#e0e0e0'}`,
                                    borderRadius: 6,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                }}>
                                    <input
                                        type="checkbox"
                                        id="foundOnGround"
                                        checked={data.data_source === 'ground_verification'}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                handleChange('ground_verification', 'data_source');
                                                handleChange('found_at_facility', 'verification_status');
                                            } else {
                                                handleChange('', 'data_source');
                                                handleChange('pending', 'verification_status');
                                            }
                                        }}
                                        style={{ width: 16, height: 16, cursor: 'pointer' }}
                                    />
                                    <label htmlFor="foundOnGround" style={{ margin: 0, cursor: 'pointer', fontWeight: 500 }}>
                                        🔍 This vehicle was <strong>found on the ground</strong> and is not in the imported list
                                        <span style={{ display: 'block', fontSize: 12, fontWeight: 400, color: '#888', marginTop: 2 }}>
                                            Check this when capturing a vehicle discovered during the ground verification exercise
                                        </span>
                                    </label>
                                </div>
                            </div>
                            {/* ─────────────────────────────────────── */}
                            <div className="col-md-4 form-group">
                                <label className="req">Registration Plate</label>
                                <Input 
                                    value={data.serial_no || ''} 
                                    onChange={e => {
                                        const formattedValue = formatRegistrationPlate(e.target.value, data.serial_no || '');
                                        handleChange(formattedValue, 'serial_no');
                                    }}
                                    placeholder="GSD 123 UN"
                                    maxLength={14}
                                />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Engine Number</label>
                                <Input value={data.eieftnumber || ''}
                                onChange={e => handleChange(e.target.value, 'eieftnumber')}
                                placeholder="Engine Number" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Chassis Number</label>
                                <Input value={data.order_number || ''} 
                                onChange={e => handleChange(e.target.value, 'order_number')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Model Year</label>
                                <Input value={data.eimonth || ''} 
                                onChange={e => handleChange(e.target.value, 'eimonth')}
                                placeholder="e.g. 2019" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Mileage</label>
                                <Input value={data.delivery_note_number || ''} 
                                onChange={e => handleChange(e.target.value, 'delivery_note_number')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Vehicle Status</label>
                                <div>
                                    <AntdSelect 
                                    showSearch options={filteredStatuses} 
                                    value={data.functional_status} 
                                    onChange={v => handleChange(v, 'functional_status')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Maintenance Needs</label>
                                <select 
                                    className="form-control"
                                    value={data.eistatus || ''} 
                                    onChange={e => handleChange(e.target.value, 'eistatus')}
                                >
                                    <option value="">Select maintenance type</option>
                                    <option value="Minor service">Minor service</option>
                                    <option value="Major service">Major service</option>
                                </select>
                            </div>

                            {/* ── 8 new Phase 3 fields ── */}
                            <div className="col-md-4 form-group">
                                <label>Region</label>
                                <select className="form-control"
                                    value={data.region || ''}
                                    onChange={e => handleChange(e.target.value, 'region')}>
                                    <option value="">Select region</option>
                                    <option value="Hhohho">Hhohho</option>
                                    <option value="Manzini">Manzini</option>
                                    <option value="Shiselweni">Shiselweni</option>
                                    <option value="Lubombo">Lubombo</option>
                                    <option value="National">National</option>
                                </select>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Assigned Programme</label>
                                <Input value={data.assigned_programme || ''}
                                    onChange={e => handleChange(e.target.value, 'assigned_programme')}
                                    placeholder="e.g. PEPFAR, GFATM, EPI" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Old Reg / Private Ref</label>
                                <Input value={data.private_ref_old_reg || ''}
                                    onChange={e => handleChange(e.target.value, 'private_ref_old_reg')}
                                    placeholder="Previous registration plate" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Engine Capacity (cc)</label>
                                <Input type="number" value={data.engine_capacity_cc || ''}
                                    onChange={e => handleChange(e.target.value, 'engine_capacity_cc')}
                                    placeholder="e.g. 2500" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Colour</label>
                                <Input value={data.colour || ''}
                                    onChange={e => handleChange(e.target.value, 'colour')}
                                    placeholder="e.g. White" />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Condition Rating (1–5)</label>
                                <select className="form-control"
                                    value={data.condition_rating || ''}
                                    onChange={e => handleChange(e.target.value, 'condition_rating')}>
                                    <option value="">Select rating</option>
                                    <option value="5">5 — Excellent</option>
                                    <option value="4">4 — Good</option>
                                    <option value="3">3 — Fair</option>
                                    <option value="2">2 — Poor</option>
                                    <option value="1">1 — Very Poor</option>
                                </select>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Procurement Method</label>
                                <select className="form-control"
                                    value={data.procurement_method || ''}
                                    onChange={e => handleChange(e.target.value, 'procurement_method')}>
                                    <option value="">Select method</option>
                                    <option value="Direct Purchase">Direct Purchase</option>
                                    <option value="Tender">Tender</option>
                                    <option value="Donation">Donation</option>
                                    <option value="Transfer">Transfer</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Funded By</label>
                                <select className="form-control"
                                    value={data.funded_by || ''}
                                    onChange={e => handleChange(e.target.value, 'funded_by')}>
                                    <option value="">Select funder</option>
                                    <option value="Government of Eswatini">Government of Eswatini</option>
                                    <option value="PEPFAR">PEPFAR</option>
                                    <option value="GFATM">GFATM (Global Fund)</option>
                                    <option value="WHO">WHO</option>
                                    <option value="UNICEF">UNICEF</option>
                                    <option value="World Bank">World Bank</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Fuel Type</label>
                                <select className="form-control"
                                    value={data.fuel_type || ''}
                                    onChange={e => handleChange(e.target.value, 'fuel_type')}>
                                    <option value="">Select fuel type</option>
                                    <option value="Diesel">Diesel</option>
                                    <option value="Petrol">Petrol</option>
                                    <option value="Hybrid">Hybrid</option>
                                    <option value="Electric">Electric</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            {/* ── end new fields ── */}
                        </>
                    )}

                    {asset_cat_id === '2' && (
                        <>
                            <div className="col-md-4 form-group">
                                <label>Identifier</label>
                                <Input value={data.serial_no || ''} 
                                onChange={e => handleChange(e.target.value, 'serial_no')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Functional Status</label>
                                <div>
                                    <AntdSelect 
                                    showSearch options={filteredStatuses} 
                                    value={data.functional_status} 
                                    onChange={v => handleChange(v, 'functional_status')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Quantity</label>
                                <div>
                                    <Input type="number" value={data.stock} onChange={e => handleChange(e.target.value, 'stock')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Cost (SZL)</label>
                                <div>
                                    <Input type="number" value={data.cost} onChange={e => handleChange(e.target.value, 'cost')} />
                                </div>
                            </div>
                        </>
                    )}

                    {asset_cat_id === '3' && (
                        <>
                            <div className="col-md-4 form-group">
                                <label>Identifier</label>
                                <Input value={data.serial_no || ''} 
                                onChange={e => handleChange(e.target.value, 'serial_no')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Functional Status</label>
                                <div>
                                    <AntdSelect 
                                    showSearch options={filteredStatuses} 
                                    value={data.functional_status} 
                                    onChange={v => handleChange(v, 'functional_status')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Quantity</label>
                                <div>
                                    <Input type="number" value={data.stock} onChange={e => handleChange(e.target.value, 'stock')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Cost (SZL)</label>
                                <div>
                                    <Input type="number" value={data.cost} onChange={e => handleChange(e.target.value, 'cost')} />
                                </div>
                            </div>
                        </>
                    )}

                    {asset_cat_id === '9' && (
                        <>
                            <div className="col-md-4 form-group">
                                <label>Batch Number</label>
                                <Input value={data.eibatchnumber || ''} 
                                onChange={e => handleChange(e.target.value, 'eibatchnumber')} />
                            </div>

                            <div className="col-md-4 form-group">
                                <label>Expiry Date</label>
                                <div>
                                    <AntdDatepicker value={data.procurement_date} onChange={v => handleChange(v, 'procurement_date')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Status</label>
                                <div>
                                    <AntdSelect 
                                    showSearch options={filteredStatuses} 
                                    value={data.functional_status} 
                                    onChange={v => handleChange(v, 'functional_status')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="req">Quantity</label>
                                <div>
                                    <Input type="number" value={data.stock} onChange={e => handleChange(e.target.value, 'stock')} />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Cost (SZL)</label>
                                <div>
                                    <Input type="number" value={data.cost} onChange={e => handleChange(e.target.value, 'cost')} />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col-md-4 form-group">
                        <label className="req">Current location</label>
                        <AntdSelect
                            showSearch
                          //  mode="multiple"
                            options={
                            asset_cat_id === '8'
                                ? stationPoints.filter(v => v.client_ids.includes(data.client_id) && v.asset_cat_ids && v.asset_cat_ids.toString().split(',').map(s=>s.trim()).includes('8'))
                                : stationPoints.filter(v => v.client_ids.includes(data.client_id) && (!v.asset_cat_ids || v.asset_cat_ids === ''))
                        }
                            value={data.station_point_ids}
                            onChange={v => handleChange(v, 'station_point_ids')}
                        />
                    </div>

                    <div className="col-md-12 form-group">
                        <label>Remarks / Comments {asset_cat_id === '8' ? '' : '(Voice Input Available)'}</label>
                        {asset_cat_id === '8' ? (
                            <Input.TextArea
                                rows={3}
                                value={data.eicomment || ''}
                                onChange={e => handleChange(e.target.value, 'eicomment')}
                                placeholder="Enter any observations, notes, or comments..."
                                style={{ resize: 'vertical' }}
                            />
                        ) : (
                            <VoiceRemarks
                                value={data.eicomment || ''}
                                onChange={(value) => handleChange(value, 'eicomment')}
                                placeholder="Enter remarks or use voice input..."
                            />
                        )}
                    </div>
                    

                    
                        <div className="col-md-4 form-group">
                            <label className="req">Is Donated?</label>
                            <div>
                                <AntdSelect
                                    options={[{ label: 'No', value: '0' }, { label: 'Yes', value: '1' }]}
                                    value={`${data.isdonated || '0'}`}
                                    onChange={v => handleChange(v, 'isdonated')}
                                    defaultValue="0"
                                />
                            </div>
                        </div>
                    

                    {data.isdonated === '1' && (
                        <div className="col-md-4 form-group">
                            <label className="req">Specify Donor</label>
                            <Input 
                                value={data.donor_name || ''} 
                                onChange={e => handleChange(e.target.value, 'donor_name')} 
                            />
                        </div>
                    )}

                    {/* ── Vehicle Documents (Blue Book, Insurance, Road Licence, etc.) ── */}
                    {asset_cat_id === '8' && data.id && (
                        <div className="col-md-12 form-group" style={{ marginTop: 16 }}>
                            <VehicleDocumentsUpload
                                vehicleId={data.id}
                                clientId={data.client_id}
                                visible={showForm}
                            />
                        </div>
                    )}
                    {/* ─────────────────────────────────────────────────────────────── */}
                </div>
            </div>
        </form>
    );

    // Render bulk mode
    const renderBulkMode = () => (
        <div>
                <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
                    <Button
                        type="dashed"
                        onClick={addNewRow}
                        icon={<PlusOutlined />}
                        style={{ flex: 1 }}
                    >
                        Add Row
                    </Button>
                    
                    <Button
                        icon={<FileExcelOutlined />}
                        onClick={() => setShowSmartImport(true)}
                        type="primary"
                        ghost
                    >
                        Smart Import from Excel
                    </Button>

                </div>
                
                <Table
                    columns={getTableColumns()}
                    dataSource={bulkData}
                    rowKey="id"
                    pagination={false}
                    scroll={{ x: 2000, y: 400 }}
                    size="small"
                    bordered
                />
        </div>
    );

    return (
        <>
            <Modal
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{`${isEditMode ? 'Edit' : 'Register'} Asset${!isEditMode ? 's' : ''}`}</span>
                        
                        {isEditMode && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '12px', color: '#666' }}>Quality Score:</span>
                                <div style={{
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    backgroundColor: qualityScore.qualityColor + '20',
                                    color: qualityScore.qualityColor
                                }}>
                                    {qualityScore.percentage}% {qualityScore.qualityLevel}
                                </div>
                                <Button
                                    type="text"
                                    size="small"
                                    onClick={() => setShowQualityPanel(!showQualityPanel)}
                                >
                                    {showQualityPanel ? 'Hide' : 'Show'} Details
                                </Button>
                            </div>
                        )}
                    </div>
                }
                open={showForm}
                okText={saving ? "Saving..." : "Save"}
                onOk={save}
                onCancel={closeForm}
                destroyOnClose
                maskClosable={false}
                zIndex={1000}
                width={isEditMode ? 800 : 1600}
                confirmLoading={saving}
                okButtonProps={{
                    disabled: saving,
                    style: isEditMode && qualityScore.criticalIssues > 0 ? {
                        backgroundColor: '#faad14',
                        borderColor: '#faad14'
                    } : {}
                }}
            >
                {isEditMode ? renderEditMode() : renderBulkMode()}
            </Modal>

            {/* Smart Excel Import Modal */}
            <IntelligentExcelImport
                visible={showSmartImport}
                onClose={() => setShowSmartImport(false)}
                onImport={handleExcelImport}
                clients={clients}
                items={items}
                stationPoints={stationPoints}
                functionalStatus={filteredStatuses}
                assetCatId={asset_cat_id}
            />

            {/* Guided Capture Panel */}
            {showForm && !isEditMode && (
                <GuidedCapturePanel 
                    clientId={bulkData.length > 0 ? bulkData[0].client_id : null}
                    stationPointId={bulkData.length > 0 ? bulkData[0].station_point_ids?.[0] : null}
                    assetCatId={asset_cat_id}
                    clients={clients}
                />
            )}
            {/* Data Quality Panel - only show in edit mode */}
            {isEditMode && (
                <DataQualityPanel 
                    qualityScore={qualityScore} 
                    isVisible={showQualityPanel && showForm} 
                />
            )}
        </>
    );
});